import { _ as n, a as t, b as o, d as e, e as r, f as i } from "./_commonjsHelpers-b0e8727a.js";
import l, { Component as u } from "react";
import { P as a } from "./index-f450c016.js";
import { m as c } from "./index-f217a905.js";
import { s } from "./style-inject.es-1f59c1d0.js";

function p() {
  return new f();
}

function f() {
  this.reset();
}

f.prototype = {
  constructor: f,
  reset: function reset() {
    this.s = this.t = 0;
  },
  add: function add(n) {
    g(y, n, this.t), g(this, y.s, this.s), this.s ? this.t += y.t : this.s = y.t;
  },
  valueOf: function valueOf() {
    return this.s;
  }
};
var y = new f();

function g(n, t, o) {
  var e = n.s = t + o,
      r = e - t,
      i = e - r;
  n.t = t - i + (o - r);
}

var h = 1e-6,
    v = Math.PI,
    P = v / 2,
    d = v / 4,
    m = 2 * v,
    S = 180 / v,
    E = v / 180,
    _ = Math.abs,
    b = Math.atan,
    w = Math.atan2,
    x = Math.cos,
    M = Math.sin,
    k = Math.sqrt;

function N(n) {
  return n > 1 ? P : n < -1 ? -P : Math.asin(n);
}

function j() {}

function z(n, t) {
  n && T.hasOwnProperty(n.type) && T[n.type](n, t);
}

var R = {
  Feature: function Feature(n, t) {
    z(n.geometry, t);
  },
  FeatureCollection: function FeatureCollection(n, t) {
    for (var o = n.features, e = -1, r = o.length; ++e < r;) {
      z(o[e].geometry, t);
    }
  }
},
    T = {
  Sphere: function Sphere(n, t) {
    t.sphere();
  },
  Point: function Point(n, t) {
    n = n.coordinates, t.point(n[0], n[1], n[2]);
  },
  MultiPoint: function MultiPoint(n, t) {
    for (var o = n.coordinates, e = -1, r = o.length; ++e < r;) {
      n = o[e], t.point(n[0], n[1], n[2]);
    }
  },
  LineString: function LineString(n, t) {
    F(n.coordinates, t, 0);
  },
  MultiLineString: function MultiLineString(n, t) {
    for (var o = n.coordinates, e = -1, r = o.length; ++e < r;) {
      F(o[e], t, 0);
    }
  },
  Polygon: function Polygon(n, t) {
    q(n.coordinates, t);
  },
  MultiPolygon: function MultiPolygon(n, t) {
    for (var o = n.coordinates, e = -1, r = o.length; ++e < r;) {
      q(o[e], t);
    }
  },
  GeometryCollection: function GeometryCollection(n, t) {
    for (var o = n.geometries, e = -1, r = o.length; ++e < r;) {
      z(o[e], t);
    }
  }
};

function F(n, t, o) {
  var e,
      r = -1,
      i = n.length - o;

  for (t.lineStart(); ++r < i;) {
    e = n[r], t.point(e[0], e[1], e[2]);
  }

  t.lineEnd();
}

function q(n, t) {
  var o = -1,
      e = n.length;

  for (t.polygonStart(); ++o < e;) {
    F(n[o], t, 1);
  }

  t.polygonEnd();
}

function C(n, t) {
  n && R.hasOwnProperty(n.type) ? R[n.type](n, t) : z(n, t);
}

p(), p();

function G(n) {
  return [w(n[1], n[0]), N(n[2])];
}

function L(n) {
  var t = n[0],
      o = n[1],
      e = x(o);
  return [e * x(t), e * M(t), M(o)];
}

function A(n, t) {
  return n[0] * t[0] + n[1] * t[1] + n[2] * t[2];
}

function D(n, t) {
  return [n[1] * t[2] - n[2] * t[1], n[2] * t[0] - n[0] * t[2], n[0] * t[1] - n[1] * t[0]];
}

function H(n, t) {
  n[0] += t[0], n[1] += t[1], n[2] += t[2];
}

function O(n, t) {
  return [n[0] * t, n[1] * t, n[2] * t];
}

function I(n) {
  var t = k(n[0] * n[0] + n[1] * n[1] + n[2] * n[2]);
  n[0] /= t, n[1] /= t, n[2] /= t;
}

p();

function Z(n, t) {
  function o(o, e) {
    return o = n(o, e), t(o[0], o[1]);
  }

  return n.invert && t.invert && (o.invert = function (o, e) {
    return (o = t.invert(o, e)) && n.invert(o[0], o[1]);
  }), o;
}

function B(n, t) {
  return [_(n) > v ? n + Math.round(-n / m) * m : n, t];
}

function W(n) {
  return function (t, o) {
    return [(t += n) > v ? t - m : t < -v ? t + m : t, o];
  };
}

function X(n) {
  var t = W(n);
  return t.invert = W(-n), t;
}

function Y(n, t) {
  var o = x(n),
      e = M(n),
      r = x(t),
      i = M(t);

  function l(n, t) {
    var l = x(t),
        u = x(n) * l,
        a = M(n) * l,
        c = M(t),
        s = c * o + u * e;
    return [w(a * r - s * i, u * o - c * e), N(s * r + a * i)];
  }

  return l.invert = function (n, t) {
    var l = x(t),
        u = x(n) * l,
        a = M(n) * l,
        c = M(t),
        s = c * r - a * i;
    return [w(a * r + c * i, u * o + s * e), N(s * o - u * e)];
  }, l;
}

function U(n, t) {
  (t = L(t))[0] -= n, I(t);
  var o,
      e = (o = -t[1]) > 1 ? 0 : o < -1 ? v : Math.acos(o);
  return ((-t[2] < 0 ? -e : e) + m - h) % m;
}

function J() {
  var n,
      t = [];
  return {
    point: function point(t, o) {
      n.push([t, o]);
    },
    lineStart: function lineStart() {
      t.push(n = []);
    },
    lineEnd: j,
    rejoin: function rejoin() {
      t.length > 1 && t.push(t.pop().concat(t.shift()));
    },
    result: function result() {
      var o = t;
      return t = [], n = null, o;
    }
  };
}

function K(n, t) {
  return _(n[0] - t[0]) < h && _(n[1] - t[1]) < h;
}

function Q(n, t, o, e) {
  this.x = n, this.z = t, this.o = o, this.e = e, this.v = !1, this.n = this.p = null;
}

function V(n, t, o, e, r) {
  var i,
      l,
      u = [],
      a = [];

  if (n.forEach(function (n) {
    if (!((t = n.length - 1) <= 0)) {
      var t,
          o,
          e = n[0],
          l = n[t];

      if (K(e, l)) {
        for (r.lineStart(), i = 0; i < t; ++i) {
          r.point((e = n[i])[0], e[1]);
        }

        r.lineEnd();
      } else u.push(o = new Q(e, n, null, !0)), a.push(o.o = new Q(e, null, o, !1)), u.push(o = new Q(l, n, null, !1)), a.push(o.o = new Q(l, null, o, !0));
    }
  }), u.length) {
    for (a.sort(t), $(u), $(a), i = 0, l = a.length; i < l; ++i) {
      a[i].e = o = !o;
    }

    for (var c, s, p = u[0];;) {
      for (var f = p, y = !0; f.v;) {
        if ((f = f.n) === p) return;
      }

      c = f.z, r.lineStart();

      do {
        if (f.v = f.o.v = !0, f.e) {
          if (y) for (i = 0, l = c.length; i < l; ++i) {
            r.point((s = c[i])[0], s[1]);
          } else e(f.x, f.n.x, 1, r);
          f = f.n;
        } else {
          if (y) for (c = f.p.z, i = c.length - 1; i >= 0; --i) {
            r.point((s = c[i])[0], s[1]);
          } else e(f.x, f.p.x, -1, r);
          f = f.p;
        }

        c = (f = f.o).z, y = !y;
      } while (!f.v);

      r.lineEnd();
    }
  }
}

function $(n) {
  if (t = n.length) {
    for (var t, o, e = 0, r = n[0]; ++e < t;) {
      r.n = o = n[e], o.p = r, r = o;
    }

    r.n = o = n[0], o.p = r;
  }
}

B.invert = B;
var nn = p();

function tn(n, t, o, e) {
  return function (r) {
    var i,
        l,
        u,
        a = t(r),
        s = J(),
        p = t(s),
        f = !1,
        y = {
      point: g,
      lineStart: E,
      lineEnd: _,
      polygonStart: function polygonStart() {
        y.point = b, y.lineStart = k, y.lineEnd = j, l = [], i = [];
      },
      polygonEnd: function polygonEnd() {
        y.point = g, y.lineStart = E, y.lineEnd = _, l = c(l);

        var n = function (n, t) {
          var o = t[0],
              e = t[1],
              r = M(e),
              i = [M(o), -x(o), 0],
              l = 0,
              u = 0;
          nn.reset(), 1 === r ? e = P + h : -1 === r && (e = -P - h);

          for (var a = 0, c = n.length; a < c; ++a) {
            if (p = (s = n[a]).length) for (var s, p, f = s[p - 1], y = f[0], g = f[1] / 2 + d, S = M(g), E = x(g), _ = 0; _ < p; ++_, y = k, S = z, E = R, f = b) {
              var b = s[_],
                  k = b[0],
                  j = b[1] / 2 + d,
                  z = M(j),
                  R = x(j),
                  T = k - y,
                  F = T >= 0 ? 1 : -1,
                  q = F * T,
                  C = q > v,
                  G = S * z;

              if (nn.add(w(G * F * M(q), E * R + G * x(q))), l += C ? T + F * m : T, C ^ y >= o ^ k >= o) {
                var A = D(L(f), L(b));
                I(A);
                var H = D(i, A);
                I(H);
                var O = (C ^ T >= 0 ? -1 : 1) * N(H[2]);
                (e > O || e === O && (A[0] || A[1])) && (u += C ^ T >= 0 ? 1 : -1);
              }
            }
          }

          return (l < -h || l < h && nn < -h) ^ 1 & u;
        }(i, e);

        l.length ? (f || (r.polygonStart(), f = !0), V(l, en, n, o, r)) : n && (f || (r.polygonStart(), f = !0), r.lineStart(), o(null, null, 1, r), r.lineEnd()), f && (r.polygonEnd(), f = !1), l = i = null;
      },
      sphere: function sphere() {
        r.polygonStart(), r.lineStart(), o(null, null, 1, r), r.lineEnd(), r.polygonEnd();
      }
    };

    function g(t, o) {
      n(t, o) && r.point(t, o);
    }

    function S(n, t) {
      a.point(n, t);
    }

    function E() {
      y.point = S, a.lineStart();
    }

    function _() {
      y.point = g, a.lineEnd();
    }

    function b(n, t) {
      u.push([n, t]), p.point(n, t);
    }

    function k() {
      p.lineStart(), u = [];
    }

    function j() {
      b(u[0][0], u[0][1]), p.lineEnd();
      var n,
          t,
          o,
          e,
          a = p.clean(),
          c = s.result(),
          y = c.length;
      if (u.pop(), i.push(u), u = null, y) if (1 & a) {
        if ((t = (o = c[0]).length - 1) > 0) {
          for (f || (r.polygonStart(), f = !0), r.lineStart(), n = 0; n < t; ++n) {
            r.point((e = o[n])[0], e[1]);
          }

          r.lineEnd();
        }
      } else y > 1 && 2 & a && c.push(c.pop().concat(c.shift())), l.push(c.filter(on));
    }

    return y;
  };
}

function on(n) {
  return n.length > 1;
}

function en(n, t) {
  return ((n = n.x)[0] < 0 ? n[1] - P - h : P - n[1]) - ((t = t.x)[0] < 0 ? t[1] - P - h : P - t[1]);
}

var rn = tn(function () {
  return !0;
}, function (n) {
  var t,
      o = NaN,
      e = NaN,
      r = NaN;
  return {
    lineStart: function lineStart() {
      n.lineStart(), t = 1;
    },
    point: function point(i, l) {
      var u = i > 0 ? v : -v,
          a = _(i - o);

      _(a - v) < h ? (n.point(o, e = (e + l) / 2 > 0 ? P : -P), n.point(r, e), n.lineEnd(), n.lineStart(), n.point(u, e), n.point(i, e), t = 0) : r !== u && a >= v && (_(o - r) < h && (o -= r * h), _(i - u) < h && (i -= u * h), e = function (n, t, o, e) {
        var r,
            i,
            l = M(n - o);
        return _(l) > h ? b((M(t) * (i = x(e)) * M(o) - M(e) * (r = x(t)) * M(n)) / (r * i * l)) : (t + e) / 2;
      }(o, e, i, l), n.point(r, e), n.lineEnd(), n.lineStart(), n.point(u, e), t = 0), n.point(o = i, e = l), r = u;
    },
    lineEnd: function lineEnd() {
      n.lineEnd(), o = e = NaN;
    },
    clean: function clean() {
      return 2 - t;
    }
  };
}, function (n, t, o, e) {
  var r;
  if (null == n) r = o * P, e.point(-v, r), e.point(0, r), e.point(v, r), e.point(v, 0), e.point(v, -r), e.point(0, -r), e.point(-v, -r), e.point(-v, 0), e.point(-v, r);else if (_(n[0] - t[0]) > h) {
    var i = n[0] < t[0] ? v : -v;
    r = o * i / 2, e.point(-i, r), e.point(0, r), e.point(i, r);
  } else e.point(t[0], t[1]);
}, [-v, -P]);

function ln(n) {
  var t = x(n),
      o = 6 * E,
      e = t > 0,
      r = _(t) > h;

  function i(n, o) {
    return x(n) * x(o) > t;
  }

  function l(n, o, e) {
    var r = [1, 0, 0],
        i = D(L(n), L(o)),
        l = A(i, i),
        u = i[0],
        a = l - u * u;
    if (!a) return !e && n;
    var c = t * l / a,
        s = -t * u / a,
        p = D(r, i),
        f = O(r, c);
    H(f, O(i, s));
    var y = p,
        g = A(f, y),
        P = A(y, y),
        d = g * g - P * (A(f, f) - 1);

    if (!(d < 0)) {
      var m = k(d),
          S = O(y, (-g - m) / P);
      if (H(S, f), S = G(S), !e) return S;
      var E,
          b = n[0],
          w = o[0],
          x = n[1],
          M = o[1];
      w < b && (E = b, b = w, w = E);
      var N = w - b,
          j = _(N - v) < h;

      if (!j && M < x && (E = x, x = M, M = E), j || N < h ? j ? x + M > 0 ^ S[1] < (_(S[0] - b) < h ? x : M) : x <= S[1] && S[1] <= M : N > v ^ (b <= S[0] && S[0] <= w)) {
        var z = O(y, (-g + m) / P);
        return H(z, f), [S, G(z)];
      }
    }
  }

  function u(t, o) {
    var r = e ? n : v - n,
        i = 0;
    return t < -r ? i |= 1 : t > r && (i |= 2), o < -r ? i |= 4 : o > r && (i |= 8), i;
  }

  return tn(i, function (n) {
    var t, o, a, c, s;
    return {
      lineStart: function lineStart() {
        c = a = !1, s = 1;
      },
      point: function point(p, f) {
        var y,
            g = [p, f],
            P = i(p, f),
            d = e ? P ? 0 : u(p, f) : P ? u(p + (p < 0 ? v : -v), f) : 0;
        if (!t && (c = a = P) && n.lineStart(), P !== a && (!(y = l(t, g)) || K(t, y) || K(g, y)) && (g[0] += h, g[1] += h, P = i(g[0], g[1])), P !== a) s = 0, P ? (n.lineStart(), y = l(g, t), n.point(y[0], y[1])) : (y = l(t, g), n.point(y[0], y[1]), n.lineEnd()), t = y;else if (r && t && e ^ P) {
          var m;
          d & o || !(m = l(g, t, !0)) || (s = 0, e ? (n.lineStart(), n.point(m[0][0], m[0][1]), n.point(m[1][0], m[1][1]), n.lineEnd()) : (n.point(m[1][0], m[1][1]), n.lineEnd(), n.lineStart(), n.point(m[0][0], m[0][1])));
        }
        !P || t && K(t, g) || n.point(g[0], g[1]), t = g, a = P, o = d;
      },
      lineEnd: function lineEnd() {
        a && n.lineEnd(), t = null;
      },
      clean: function clean() {
        return s | (c && a) << 1;
      }
    };
  }, function (t, e, r, i) {
    !function (n, t, o, e, r, i) {
      if (o) {
        var l = x(t),
            u = M(t),
            a = e * o;
        null == r ? (r = t + e * m, i = t - a / 2) : (r = U(l, r), i = U(l, i), (e > 0 ? r < i : r > i) && (r += e * m));

        for (var c, s = r; e > 0 ? s > i : s < i; s -= a) {
          c = G([l, -u * x(s), -u * M(s)]), n.point(c[0], c[1]);
        }
      }
    }(i, n, o, r, t, e);
  }, e ? [0, -n] : [-v, n - v]);
}

var un = 1e9,
    an = -un;

function cn(n, t, o, e) {
  function r(r, i) {
    return n <= r && r <= o && t <= i && i <= e;
  }

  function i(r, i, u, c) {
    var s = 0,
        p = 0;
    if (null == r || (s = l(r, u)) !== (p = l(i, u)) || a(r, i) < 0 ^ u > 0) do {
      c.point(0 === s || 3 === s ? n : o, s > 1 ? e : t);
    } while ((s = (s + u + 4) % 4) !== p);else c.point(i[0], i[1]);
  }

  function l(e, r) {
    return _(e[0] - n) < h ? r > 0 ? 0 : 3 : _(e[0] - o) < h ? r > 0 ? 2 : 1 : _(e[1] - t) < h ? r > 0 ? 1 : 0 : r > 0 ? 3 : 2;
  }

  function u(n, t) {
    return a(n.x, t.x);
  }

  function a(n, t) {
    var o = l(n, 1),
        e = l(t, 1);
    return o !== e ? o - e : 0 === o ? t[1] - n[1] : 1 === o ? n[0] - t[0] : 2 === o ? n[1] - t[1] : t[0] - n[0];
  }

  return function (l) {
    var a,
        s,
        p,
        f,
        y,
        g,
        h,
        v,
        P,
        d,
        m,
        S = l,
        E = J(),
        _ = {
      point: b,
      lineStart: function lineStart() {
        _.point = w, s && s.push(p = []);
        d = !0, P = !1, h = v = NaN;
      },
      lineEnd: function lineEnd() {
        a && (w(f, y), g && P && E.rejoin(), a.push(E.result()));
        _.point = b, P && S.lineEnd();
      },
      polygonStart: function polygonStart() {
        S = E, a = [], s = [], m = !0;
      },
      polygonEnd: function polygonEnd() {
        var t = function () {
          for (var t = 0, o = 0, r = s.length; o < r; ++o) {
            for (var i, l, u = s[o], a = 1, c = u.length, p = u[0], f = p[0], y = p[1]; a < c; ++a) {
              i = f, l = y, p = u[a], f = p[0], y = p[1], l <= e ? y > e && (f - i) * (e - l) > (y - l) * (n - i) && ++t : y <= e && (f - i) * (e - l) < (y - l) * (n - i) && --t;
            }
          }

          return t;
        }(),
            o = m && t,
            r = (a = c(a)).length;

        (o || r) && (l.polygonStart(), o && (l.lineStart(), i(null, null, 1, l), l.lineEnd()), r && V(a, u, t, i, l), l.polygonEnd());
        S = l, a = s = p = null;
      }
    };

    function b(n, t) {
      r(n, t) && S.point(n, t);
    }

    function w(i, l) {
      var u = r(i, l);
      if (s && p.push([i, l]), d) f = i, y = l, g = u, d = !1, u && (S.lineStart(), S.point(i, l));else if (u && P) S.point(i, l);else {
        var a = [h = Math.max(an, Math.min(un, h)), v = Math.max(an, Math.min(un, v))],
            c = [i = Math.max(an, Math.min(un, i)), l = Math.max(an, Math.min(un, l))];
        !function (n, t, o, e, r, i) {
          var l,
              u = n[0],
              a = n[1],
              c = 0,
              s = 1,
              p = t[0] - u,
              f = t[1] - a;

          if (l = o - u, p || !(l > 0)) {
            if (l /= p, p < 0) {
              if (l < c) return;
              l < s && (s = l);
            } else if (p > 0) {
              if (l > s) return;
              l > c && (c = l);
            }

            if (l = r - u, p || !(l < 0)) {
              if (l /= p, p < 0) {
                if (l > s) return;
                l > c && (c = l);
              } else if (p > 0) {
                if (l < c) return;
                l < s && (s = l);
              }

              if (l = e - a, f || !(l > 0)) {
                if (l /= f, f < 0) {
                  if (l < c) return;
                  l < s && (s = l);
                } else if (f > 0) {
                  if (l > s) return;
                  l > c && (c = l);
                }

                if (l = i - a, f || !(l < 0)) {
                  if (l /= f, f < 0) {
                    if (l > s) return;
                    l > c && (c = l);
                  } else if (f > 0) {
                    if (l < c) return;
                    l < s && (s = l);
                  }

                  return c > 0 && (n[0] = u + c * p, n[1] = a + c * f), s < 1 && (t[0] = u + s * p, t[1] = a + s * f), !0;
                }
              }
            }
          }
        }(a, c, n, t, o, e) ? u && (S.lineStart(), S.point(i, l), m = !1) : (P || (S.lineStart(), S.point(a[0], a[1])), S.point(c[0], c[1]), u || S.lineEnd(), m = !1);
      }
      h = i, v = l, P = u;
    }

    return _;
  };
}

p();

function sn(n) {
  return n;
}

var pn,
    fn,
    yn,
    gn,
    hn = p(),
    vn = p(),
    Pn = {
  point: j,
  lineStart: j,
  lineEnd: j,
  polygonStart: function polygonStart() {
    Pn.lineStart = dn, Pn.lineEnd = En;
  },
  polygonEnd: function polygonEnd() {
    Pn.lineStart = Pn.lineEnd = Pn.point = j, hn.add(_(vn)), vn.reset();
  },
  result: function result() {
    var n = hn / 2;
    return hn.reset(), n;
  }
};

function dn() {
  Pn.point = mn;
}

function mn(n, t) {
  Pn.point = Sn, pn = yn = n, fn = gn = t;
}

function Sn(n, t) {
  vn.add(gn * n - yn * t), yn = n, gn = t;
}

function En() {
  Sn(pn, fn);
}

var _n = 1 / 0,
    bn = _n,
    wn = -_n,
    xn = wn,
    Mn = {
  point: function point(n, t) {
    n < _n && (_n = n);
    n > wn && (wn = n);
    t < bn && (bn = t);
    t > xn && (xn = t);
  },
  lineStart: j,
  lineEnd: j,
  polygonStart: j,
  polygonEnd: j,
  result: function result() {
    var n = [[_n, bn], [wn, xn]];
    return wn = xn = -(bn = _n = 1 / 0), n;
  }
};

var kn,
    Nn,
    jn,
    zn,
    Rn = 0,
    Tn = 0,
    Fn = 0,
    qn = 0,
    Cn = 0,
    Gn = 0,
    Ln = 0,
    An = 0,
    Dn = 0,
    Hn = {
  point: On,
  lineStart: In,
  lineEnd: Wn,
  polygonStart: function polygonStart() {
    Hn.lineStart = Xn, Hn.lineEnd = Yn;
  },
  polygonEnd: function polygonEnd() {
    Hn.point = On, Hn.lineStart = In, Hn.lineEnd = Wn;
  },
  result: function result() {
    var n = Dn ? [Ln / Dn, An / Dn] : Gn ? [qn / Gn, Cn / Gn] : Fn ? [Rn / Fn, Tn / Fn] : [NaN, NaN];
    return Rn = Tn = Fn = qn = Cn = Gn = Ln = An = Dn = 0, n;
  }
};

function On(n, t) {
  Rn += n, Tn += t, ++Fn;
}

function In() {
  Hn.point = Zn;
}

function Zn(n, t) {
  Hn.point = Bn, On(jn = n, zn = t);
}

function Bn(n, t) {
  var o = n - jn,
      e = t - zn,
      r = k(o * o + e * e);
  qn += r * (jn + n) / 2, Cn += r * (zn + t) / 2, Gn += r, On(jn = n, zn = t);
}

function Wn() {
  Hn.point = On;
}

function Xn() {
  Hn.point = Un;
}

function Yn() {
  Jn(kn, Nn);
}

function Un(n, t) {
  Hn.point = Jn, On(kn = jn = n, Nn = zn = t);
}

function Jn(n, t) {
  var o = n - jn,
      e = t - zn,
      r = k(o * o + e * e);
  qn += r * (jn + n) / 2, Cn += r * (zn + t) / 2, Gn += r, Ln += (r = zn * n - jn * t) * (jn + n), An += r * (zn + t), Dn += 3 * r, On(jn = n, zn = t);
}

function Kn(n) {
  this._context = n;
}

Kn.prototype = {
  _radius: 4.5,
  pointRadius: function pointRadius(n) {
    return this._radius = n, this;
  },
  polygonStart: function polygonStart() {
    this._line = 0;
  },
  polygonEnd: function polygonEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._point = 0;
  },
  lineEnd: function lineEnd() {
    0 === this._line && this._context.closePath(), this._point = NaN;
  },
  point: function point(n, t) {
    switch (this._point) {
      case 0:
        this._context.moveTo(n, t), this._point = 1;
        break;

      case 1:
        this._context.lineTo(n, t);

        break;

      default:
        this._context.moveTo(n + this._radius, t), this._context.arc(n, t, this._radius, 0, m);
    }
  },
  result: j
};
var Qn,
    Vn,
    $n,
    nt,
    tt,
    ot = p(),
    et = {
  point: j,
  lineStart: function lineStart() {
    et.point = rt;
  },
  lineEnd: function lineEnd() {
    Qn && it(Vn, $n), et.point = j;
  },
  polygonStart: function polygonStart() {
    Qn = !0;
  },
  polygonEnd: function polygonEnd() {
    Qn = null;
  },
  result: function result() {
    var n = +ot;
    return ot.reset(), n;
  }
};

function rt(n, t) {
  et.point = it, Vn = nt = n, $n = tt = t;
}

function it(n, t) {
  nt -= n, tt -= t, ot.add(k(nt * nt + tt * tt)), nt = n, tt = t;
}

function lt() {
  this._string = [];
}

function ut(n) {
  return "m0," + n + "a" + n + "," + n + " 0 1,1 0," + -2 * n + "a" + n + "," + n + " 0 1,1 0," + 2 * n + "z";
}

function at(n, t) {
  var o,
      e,
      r = 4.5;

  function i(n) {
    return n && ("function" == typeof r && e.pointRadius(+r.apply(this, arguments)), C(n, o(e))), e.result();
  }

  return i.area = function (n) {
    return C(n, o(Pn)), Pn.result();
  }, i.measure = function (n) {
    return C(n, o(et)), et.result();
  }, i.bounds = function (n) {
    return C(n, o(Mn)), Mn.result();
  }, i.centroid = function (n) {
    return C(n, o(Hn)), Hn.result();
  }, i.projection = function (t) {
    return arguments.length ? (o = null == t ? (n = null, sn) : (n = t).stream, i) : n;
  }, i.context = function (n) {
    return arguments.length ? (e = null == n ? (t = null, new lt()) : new Kn(t = n), "function" != typeof r && e.pointRadius(r), i) : t;
  }, i.pointRadius = function (n) {
    return arguments.length ? (r = "function" == typeof n ? n : (e.pointRadius(+n), +n), i) : r;
  }, i.projection(n).context(t);
}

function ct(n) {
  return function (t) {
    var o = new st();

    for (var e in n) {
      o[e] = n[e];
    }

    return o.stream = t, o;
  };
}

function st() {}

function pt(n, t, o) {
  var e = n.clipExtent && n.clipExtent();
  return n.scale(150).translate([0, 0]), null != e && n.clipExtent(null), C(o, n.stream(Mn)), t(Mn.result()), null != e && n.clipExtent(e), n;
}

function ft(n, t, o) {
  return pt(n, function (o) {
    var e = t[1][0] - t[0][0],
        r = t[1][1] - t[0][1],
        i = Math.min(e / (o[1][0] - o[0][0]), r / (o[1][1] - o[0][1])),
        l = +t[0][0] + (e - i * (o[1][0] + o[0][0])) / 2,
        u = +t[0][1] + (r - i * (o[1][1] + o[0][1])) / 2;
    n.scale(150 * i).translate([l, u]);
  }, o);
}

lt.prototype = {
  _radius: 4.5,
  _circle: ut(4.5),
  pointRadius: function pointRadius(n) {
    return (n = +n) !== this._radius && (this._radius = n, this._circle = null), this;
  },
  polygonStart: function polygonStart() {
    this._line = 0;
  },
  polygonEnd: function polygonEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._point = 0;
  },
  lineEnd: function lineEnd() {
    0 === this._line && this._string.push("Z"), this._point = NaN;
  },
  point: function point(n, t) {
    switch (this._point) {
      case 0:
        this._string.push("M", n, ",", t), this._point = 1;
        break;

      case 1:
        this._string.push("L", n, ",", t);

        break;

      default:
        null == this._circle && (this._circle = ut(this._radius)), this._string.push("M", n, ",", t, this._circle);
    }
  },
  result: function result() {
    if (this._string.length) {
      var n = this._string.join("");

      return this._string = [], n;
    }

    return null;
  }
}, st.prototype = {
  constructor: st,
  point: function point(n, t) {
    this.stream.point(n, t);
  },
  sphere: function sphere() {
    this.stream.sphere();
  },
  lineStart: function lineStart() {
    this.stream.lineStart();
  },
  lineEnd: function lineEnd() {
    this.stream.lineEnd();
  },
  polygonStart: function polygonStart() {
    this.stream.polygonStart();
  },
  polygonEnd: function polygonEnd() {
    this.stream.polygonEnd();
  }
};
var yt = 16,
    gt = x(30 * E);

function ht(n, t) {
  return +t ? function (n, t) {
    function o(e, r, i, l, u, a, c, s, p, f, y, g, v, P) {
      var d = c - e,
          m = s - r,
          S = d * d + m * m;

      if (S > 4 * t && v--) {
        var E = l + f,
            b = u + y,
            x = a + g,
            M = k(E * E + b * b + x * x),
            j = N(x /= M),
            z = _(_(x) - 1) < h || _(i - p) < h ? (i + p) / 2 : w(b, E),
            R = n(z, j),
            T = R[0],
            F = R[1],
            q = T - e,
            C = F - r,
            G = m * q - d * C;
        (G * G / S > t || _((d * q + m * C) / S - .5) > .3 || l * f + u * y + a * g < gt) && (o(e, r, i, l, u, a, T, F, z, E /= M, b /= M, x, v, P), P.point(T, F), o(T, F, z, E, b, x, c, s, p, f, y, g, v, P));
      }
    }

    return function (t) {
      var e,
          r,
          i,
          l,
          u,
          a,
          c,
          s,
          p,
          f,
          y,
          g,
          h = {
        point: v,
        lineStart: P,
        lineEnd: m,
        polygonStart: function polygonStart() {
          t.polygonStart(), h.lineStart = S;
        },
        polygonEnd: function polygonEnd() {
          t.polygonEnd(), h.lineStart = P;
        }
      };

      function v(o, e) {
        o = n(o, e), t.point(o[0], o[1]);
      }

      function P() {
        s = NaN, h.point = d, t.lineStart();
      }

      function d(e, r) {
        var i = L([e, r]),
            l = n(e, r);
        o(s, p, c, f, y, g, s = l[0], p = l[1], c = e, f = i[0], y = i[1], g = i[2], yt, t), t.point(s, p);
      }

      function m() {
        h.point = v, t.lineEnd();
      }

      function S() {
        P(), h.point = E, h.lineEnd = _;
      }

      function E(n, t) {
        d(e = n, t), r = s, i = p, l = f, u = y, a = g, h.point = d;
      }

      function _() {
        o(s, p, c, f, y, g, r, i, e, l, u, a, yt, t), h.lineEnd = m, m();
      }

      return h;
    };
  }(n, t) : function (n) {
    return ct({
      point: function point(t, o) {
        t = n(t, o), this.stream.point(t[0], t[1]);
      }
    });
  }(n);
}

var vt,
    Pt = ct({
  point: function point(n, t) {
    this.stream.point(n * E, t * E);
  }
});

function dt(n, t, o, e) {
  var r = x(e),
      i = M(e),
      l = r * n,
      u = i * n,
      a = r / n,
      c = i / n,
      s = (i * o - r * t) / n,
      p = (i * t + r * o) / n;

  function f(n, e) {
    return [l * n - u * e + t, o - u * n - l * e];
  }

  return f.invert = function (n, t) {
    return [a * n - c * t + s, p - c * n - a * t];
  }, f;
}

function mt(n) {
  return function (n) {
    var t,
        o,
        e,
        r,
        i,
        l,
        u,
        a,
        c,
        s,
        p = 150,
        f = 480,
        y = 250,
        g = 0,
        h = 0,
        v = 0,
        P = 0,
        d = 0,
        _ = 0,
        b = null,
        w = rn,
        x = null,
        M = sn,
        N = .5;

    function j(n) {
      return a(n[0] * E, n[1] * E);
    }

    function z(n) {
      return (n = a.invert(n[0], n[1])) && [n[0] * S, n[1] * S];
    }

    function R() {
      var n = dt(p, 0, 0, _).apply(null, t(g, h)),
          e = (_ ? dt : function (n, t, o) {
        function e(e, r) {
          return [t + n * e, o - n * r];
        }

        return e.invert = function (e, r) {
          return [(e - t) / n, (o - r) / n];
        }, e;
      })(p, f - n[0], y - n[1], _);
      return o = function (n, t, o) {
        return (n %= m) ? t || o ? Z(X(n), Y(t, o)) : X(n) : t || o ? Y(t, o) : B;
      }(v, P, d), u = Z(t, e), a = Z(o, u), l = ht(u, N), T();
    }

    function T() {
      return c = s = null, j;
    }

    return j.stream = function (n) {
      return c && s === n ? c : c = Pt(function (n) {
        return ct({
          point: function point(t, o) {
            var e = n(t, o);
            return this.stream.point(e[0], e[1]);
          }
        });
      }(o)(w(l(M(s = n)))));
    }, j.preclip = function (n) {
      return arguments.length ? (w = n, b = void 0, T()) : w;
    }, j.postclip = function (n) {
      return arguments.length ? (M = n, x = e = r = i = null, T()) : M;
    }, j.clipAngle = function (n) {
      return arguments.length ? (w = +n ? ln(b = n * E) : (b = null, rn), T()) : b * S;
    }, j.clipExtent = function (n) {
      return arguments.length ? (M = null == n ? (x = e = r = i = null, sn) : cn(x = +n[0][0], e = +n[0][1], r = +n[1][0], i = +n[1][1]), T()) : null == x ? null : [[x, e], [r, i]];
    }, j.scale = function (n) {
      return arguments.length ? (p = +n, R()) : p;
    }, j.translate = function (n) {
      return arguments.length ? (f = +n[0], y = +n[1], R()) : [f, y];
    }, j.center = function (n) {
      return arguments.length ? (g = n[0] % 360 * E, h = n[1] % 360 * E, R()) : [g * S, h * S];
    }, j.rotate = function (n) {
      return arguments.length ? (v = n[0] % 360 * E, P = n[1] % 360 * E, d = n.length > 2 ? n[2] % 360 * E : 0, R()) : [v * S, P * S, d * S];
    }, j.angle = function (n) {
      return arguments.length ? (_ = n % 360 * E, R()) : _ * S;
    }, j.precision = function (n) {
      return arguments.length ? (l = ht(u, N = n * n), T()) : k(N);
    }, j.fitExtent = function (n, t) {
      return ft(j, n, t);
    }, j.fitSize = function (n, t) {
      return function (n, t, o) {
        return ft(n, [[0, 0], t], o);
      }(j, n, t);
    }, j.fitWidth = function (n, t) {
      return function (n, t, o) {
        return pt(n, function (o) {
          var e = +t,
              r = e / (o[1][0] - o[0][0]),
              i = (e - r * (o[1][0] + o[0][0])) / 2,
              l = -r * o[0][1];
          n.scale(150 * r).translate([i, l]);
        }, o);
      }(j, n, t);
    }, j.fitHeight = function (n, t) {
      return function (n, t, o) {
        return pt(n, function (o) {
          var e = +t,
              r = e / (o[1][1] - o[0][1]),
              i = -r * o[0][0],
              l = (e - r * (o[1][1] + o[0][1])) / 2;
          n.scale(150 * r).translate([i, l]);
        }, o);
      }(j, n, t);
    }, function () {
      return t = n.apply(this, arguments), j.invert = t.invert && z, R();
    };
  }(function () {
    return n;
  })();
}

function St(n, t) {
  return [x(t) * M(n), M(t)];
}

function Et() {
  return mt(St).scale(249.5).clipAngle(90 + h);
}

function _t(n) {
  return n;
}

function bt(n, t) {
  var o = t.id,
      e = t.bbox,
      r = null == t.properties ? {} : t.properties,
      i = function (n, t) {
    var o = function (n) {
      if (null == n) return _t;
      var t,
          o,
          e = n.scale[0],
          r = n.scale[1],
          i = n.translate[0],
          l = n.translate[1];
      return function (n, u) {
        u || (t = o = 0);
        var a = 2,
            c = n.length,
            s = new Array(c);

        for (s[0] = (t += n[0]) * e + i, s[1] = (o += n[1]) * r + l; a < c;) {
          s[a] = n[a], ++a;
        }

        return s;
      };
    }(n.transform),
        e = n.arcs;

    function r(n, t) {
      t.length && t.pop();

      for (var r = e[n < 0 ? ~n : n], i = 0, l = r.length; i < l; ++i) {
        t.push(o(r[i], i));
      }

      n < 0 && function (n, t) {
        for (var o, e = n.length, r = e - t; r < --e;) {
          o = n[r], n[r++] = n[e], n[e] = o;
        }
      }(t, l);
    }

    function i(n) {
      return o(n);
    }

    function l(n) {
      for (var t = [], o = 0, e = n.length; o < e; ++o) {
        r(n[o], t);
      }

      return t.length < 2 && t.push(t[0]), t;
    }

    function u(n) {
      for (var t = l(n); t.length < 4;) {
        t.push(t[0]);
      }

      return t;
    }

    function a(n) {
      return n.map(u);
    }

    return function n(t) {
      var o,
          e = t.type;

      switch (e) {
        case "GeometryCollection":
          return {
            type: e,
            geometries: t.geometries.map(n)
          };

        case "Point":
          o = i(t.coordinates);
          break;

        case "MultiPoint":
          o = t.coordinates.map(i);
          break;

        case "LineString":
          o = l(t.arcs);
          break;

        case "MultiLineString":
          o = t.arcs.map(l);
          break;

        case "Polygon":
          o = a(t.arcs);
          break;

        case "MultiPolygon":
          o = t.arcs.map(a);
          break;

        default:
          return null;
      }

      return {
        type: e,
        coordinates: o
      };
    }(t);
  }(n, t);

  return null == o && null == e ? {
    type: "Feature",
    properties: r,
    geometry: i
  } : null == e ? {
    type: "Feature",
    id: o,
    properties: r,
    geometry: i
  } : {
    type: "Feature",
    id: o,
    bbox: e,
    properties: r,
    geometry: i
  };
}

St.invert = (vt = N, function (n, t) {
  var o = k(n * n + t * t),
      e = vt(o),
      r = M(e),
      i = x(e);
  return [w(n * r, o * i), N(o && t * r / o)];
});
var wt = "miniglobe-module_globeBackground__g9rsS",
    xt = "miniglobe-module_globeSvg__yp1XI",
    Mt = "miniglobe-module_viewport__2YFvH";
s(":root {\n  --miniglobe-bg-color: #011137;\n  --miniglobe-fg-color: #99d3e1;\n  --miniglobe-viewport-color: #f00;\n}\n\n.miniglobe-module_globeBackground__g9rsS {\n  fill: var(--miniglobe-fg-color);\n  stroke: none;\n}\n\n.miniglobe-module_globeSvg__yp1XI {\n  fill: var(--miniglobe-bg-color);\n  stroke: none;\n}\n\n.miniglobe-module_viewport__2YFvH {\n  fill: none;\n  stroke: var(--miniglobe-viewport-color);\n}\n");

var kt = {
  type: "Topology",
  arcs: [[[5058, 829], [-24, -80], [-182, 7], [-76, 55], [185, -11], [97, 29]], [[873, 874], [-80, -11], [-109, 86], [104, 18], [74, -55], [11, -38]], [[5664, 995], [52, -36], [24, -129], [-300, -83], [-99, 5], [-48, 62], [90, 23], [134, 158], [84, 18], [63, -18]], [[2469, 1373], [81, -27], [-98, -15], [17, 42]], [[2287, 1375], [-15, -21], [-58, 23], [31, 17], [42, -19]], [[3403, 1504], [84, -43], [-160, -5], [-42, 17], [4, 49], [114, -18]], [[4685, 1585], [-14, -101], [-96, -28], [-131, 12], [-34, 58], [75, 43], [48, -3], [14, 140], [24, 39], [61, -18], [53, -142]], [[5099, 2151], [-84, -13], [-80, -65], [-3, -64], [19, -27], [-68, -26], [-74, -90], [-7, -31], [37, -60], [67, -46], [71, -155], [6, -77], [28, -96], [-5, -44], [-48, -62], [-56, -11], [-44, -57], [-229, -80], [-34, -35], [-279, -6], [151, -100], [-47, -26], [-133, -13], [-4, -67], [112, -89], [165, -36], [136, -52], [208, -36], [262, -93], [142, 50], [162, 44], [105, 2], [187, -31], [86, 60], [106, 2], [162, 36], [245, 47], [-47, 90], [-250, -16], [-6, 93], [149, 57], [140, 81], [143, 33], [179, 31], [155, 65], [77, 52], [-32, 52], [43, 61], [89, 36], [127, 120], [121, -36], [23, 64], [56, -39], [50, -5], [107, 24], [112, -11], [137, 38], [126, 50], [101, 20], [54, -69], [48, 17], [61, 55], [106, -5], [139, 12], [93, -15], [46, -52], [47, 14], [144, 5], [237, 90], [47, 73], [44, -13], [52, -49], [44, 7], [61, -51], [57, 56], [82, 42], [90, 28], [101, 55], [39, -9], [65, 52], [74, 18], [9, 29], [69, 39], [81, 20], [77, -13], [37, -59], [63, -51], [50, -9], [63, -46], [40, -5], [70, 51], [39, -18], [164, -26], [35, -87], [-7, -59], [-73, -52], [47, -63], [-41, -66], [80, -34], [49, 15], [37, 63], [49, 51], [33, 70], [159, 34], [62, 95], [153, 93], [42, -8], [156, 36], [132, -30], [41, 10], [144, -5], [32, -18], [121, 23], [44, -11], [131, 140], [59, -34], [81, -80], [80, -2], [91, 21], [63, 48], [78, 21], [84, -69], [46, 4], [79, -43], [96, -1], [61, 52], [38, 6], [82, -19], [77, 13], [76, -17], [83, 28], [90, 3], [124, 30], [31, -62], [35, -15], [141, 12], [94, 1], [103, -10], [29, -26], [19, -55], [92, -41], [154, -41], [75, 26], [106, -68], [100, -18], [20, -33], [127, -62], [144, -1], [97, -18], [117, -61], [-81, -163], [-55, -13], [-79, -47], [-78, -90], [-28, -65], [-3, -68], [52, -93], [95, -48], [-220, -34], [-83, -148], [114, -93], [269, -106], [21, -41], [276, -28], [169, -46], [0, -440], [-15121, 0], [0, 440], [2, -1], [234, 16], [186, 54], [123, -57], [376, -67], [121, 23], [280, -43], [228, 48], [9, 39], [-301, 23], [-149, 50], [31, 137], [-102, 53], [134, 34], [61, -28], [144, 55], [19, 62], [-116, 48], [-244, 24], [-114, 87], [45, 60], [136, 20], [101, -28], [156, 68], [64, 8], [-4, 92], [79, -13], [112, 37], [117, 10], [153, 56], [124, 0], [56, -15], [113, 13], [119, -16], [240, 3], [93, 37], [53, -18], [96, 44], [69, -83], [43, 25], [156, -64], [112, 20], [178, -30], [22, 36], [-47, 57], [-79, 38], [-23, 93], [141, -12], [167, -71], [164, 37], [43, -19], [125, 32], [102, -6], [34, -33], [156, -31], [50, 60], [42, -32], [57, 8], [72, -46], [142, 48], [164, 32], [66, 44], [5, 70], [-52, 128], [2, 65], [42, 98], [-13, 68], [71, 93], [62, 51], [17, 36], [49, 44], [131, 57], [54, 47], [42, -39], [-42, -25]], [[4715, 3009], [54, -50], [59, -21], [-19, -41], [-75, -9], [-36, -26], [-45, 10], [-75, 37], [-96, 91], [-23, 76], [59, -56], [56, -30], [35, 95], [39, 35], [30, -10], [37, -101]], [[5101, 3238], [34, -38], [-13, -29], [-56, -25], [-19, 29], [-36, -37], [-21, 37], [50, 50], [36, -21], [25, 34]], [[10512, 3353], [-64, -5], [8, 96], [27, -26], [40, -11], [-11, -54]], [[13668, 4096], [40, -29], [56, 27], [25, -5], [3, -99], [-63, -131], [-34, 7], [-26, 71], [-6, 55], [-24, 73], [29, 31]], [[14828, 4085], [9, -34], [30, 34], [12, -71], [-81, -174], [-36, -31], [-35, -139], [-54, -61], [-39, 2], [-27, 27], [-46, 6], [-7, 31], [23, 61], [53, 82], [27, 16], [66, 75], [25, 44], [41, 129], [30, 39], [9, -36]], [[14895, 4482], [30, -88], [60, -56], [28, -7], [24, 32], [22, -10], [-23, -122], [-32, 2], [-8, -61], [-42, -118], [-33, -33], [-25, 34], [25, 68], [-14, 46], [-45, 34], [1, 30], [30, 29], [5, 118], [-36, 104], [-33, 74], [-17, 59], [15, 7], [23, -47], [33, -21], [12, -74]], [[14580, 5647], [-16, -20], [-53, 60], [-55, 102], [12, 27], [24, -28], [88, -141]], [[15053, 6048], [14, -24], [-7, -44], [-26, -11], [-23, 10], [-4, 37], [16, 28], [30, 4]], [[15094, 6093], [-27, -18], [-5, 31], [59, 48], [0, -41], [-27, -20]], [[3, 6117], [-3, -4], [0, 41], [9, 4], [-6, -41]], [[14610, 6120], [-13, -11], [-14, 37], [1, 22], [26, -48]], [[14579, 6248], [7, -67], [-20, 6], [-7, 87], [20, -26]], [[9663, 6363], [7, -100], [11, -39], [-12, -65], [-29, -92], [-3, -70], [-37, -212], [-26, -158], [-16, -115], [-19, -97], [-35, -20], [-36, -35], [-58, 51], [-11, 44], [-3, 74], [-15, 66], [-4, 60], [8, 60], [39, 105], [4, 53], [-18, 92], [-3, 77], [15, 46], [5, 53], [21, 3], [39, 32], [19, 2], [58, 98], [48, 126], [1, 50], [14, 37], [26, -71], [10, -55]], [[13590, 6345], [16, -65], [27, 31], [34, -67], [-5, -37], [16, -113], [10, -10], [12, -71], [-4, -44], [13, -56], [46, -43], [58, -76], [-6, -20], [24, -53], [16, -90], [17, 19], [27, -24], [8, -88], [49, -83], [33, -67], [12, -67], [-2, -99], [20, -71], [-3, -73], [-18, -113], [-8, -108], [-18, -75], [-31, -41], [-30, -106], [-12, -72], [-16, -41], [-11, -62], [-3, -84], [-24, -29], [-47, -3], [-39, -34], [-45, -68], [-77, 79], [-36, -60], [-61, 35], [-64, 31], [-27, 51], [-18, 105], [-21, 34], [-40, 10], [14, 40], [-10, 62], [-21, -58], [-15, 31], [22, 89], [-3, 62], [-34, -71], [-26, -29], [-17, -66], [-32, 34], [1, 44], [-41, 111], [-54, 51], [-29, 2], [-40, 40], [-76, -7], [-102, -58], [-40, 6], [-44, -43], [-37, -19], [-23, -78], [-62, -9], [-38, 15], [-59, -13], [-78, -91], [-59, 4], [-67, 69], [1, 47], [21, 12], [10, 106], [-4, 50], [-22, 84], [-5, 95], [-18, 78], [-19, 34], [-5, 65], [-26, 142], [33, -13], [-35, 116], [19, 111], [-4, 48], [20, -3], [18, 57], [34, 28], [21, 35], [32, 31], [30, -4], [33, 31], [26, 9], [17, 26], [24, -2], [44, 25], [23, 37], [10, 44], [25, 42], [3, 79], [29, 71], [18, -72], [18, 16], [-15, 40], [13, 40], [19, -18], [5, 63], [55, 112], [58, 34], [31, -38], [23, -50], [53, -8], [-9, 46], [33, 109], [18, 48], [25, 29], [22, -10], [35, 16], [-1, 42], [20, 19], [22, -34], [35, -21], [12, 8], [26, -26], [51, 33], [19, -41], [-64, -197], [3, -23], [33, -46], [33, -27], [52, -78], [33, -21], [7, -26], [40, -28], [28, 28], [34, 194], [-7, 112], [7, 107], [18, 90], [17, 55], [11, -41], [3, -52], [28, -87], [1, -78]], [[14370, 6618], [-18, -28], [-16, 52], [34, -24]], [[12631, 6639], [-18, -2], [-56, 58], [40, 17], [36, -51], [-2, -22]], [[14317, 6669], [-42, 7], [-7, 46], [28, -13], [21, -40]], [[14352, 6692], [-7, -15], [-31, 72], [-9, 49], [15, 0], [15, -66], [17, -40]], [[12787, 6647], [-36, -18], [-1, 38], [18, 51], [42, 33], [4, 19], [37, 19], [29, 3], [14, -23], [-79, -60], [-28, -62]], [[12513, 6817], [15, -22], [26, 7], [10, -36], [-78, -28], [-8, 49], [23, 1], [12, 29]], [[12723, 6817], [-6, -46], [-63, -24], [-56, 11], [0, 30], [33, 17], [26, -25], [28, 7], [38, 30]], [[14276, 6797], [-31, 19], [-23, 30], [-10, 36], [54, -59], [10, -26]], [[14178, 6879], [-27, 15], [-17, 34], [2, 14], [42, -63]], [[12123, 6927], [80, -8], [10, 34], [78, -40], [15, -54], [63, -15], [51, -50], [-47, -31], [-47, 33], [-81, 4], [-40, 15], [-48, 32], [-31, 8], [-18, -10], [-76, 34], [-7, 36], [-39, 6], [29, 79], [51, -5], [51, -39], [6, -29]], [[13219, 6974], [-21, -57], [-4, 63], [16, 58], [9, -64]], [[14108, 6923], [-12, -8], [-36, 85], [14, 28], [34, -105]], [[13944, 7035], [-73, -70], [-22, 0], [-59, 48], [4, 25], [37, -12], [64, 11], [35, 58], [-4, 49], [33, -12], [-1, -46], [-14, -51]], [[12905, 7203], [-15, -28], [-29, 16], [-9, 36], [43, 4], [10, -28]], [[13041, 7233], [15, -63], [-36, 34], [-35, 7], [-52, -2], [10, 45], [51, 4], [47, -25]], [[13993, 7116], [-13, -22], [-25, 127], [33, -61], [5, -44]], [[13195, 7395], [12, -135], [43, -49], [35, 88], [48, 50], [38, 0], [67, -59], [45, -15], [73, -58], [77, -47], [53, -85], [6, -49], [70, -51], [10, -45], [-38, -8], [9, -56], [37, -55], [28, -88], [24, 3], [-2, -37], [20, -30], [45, -35], [-5, -24], [-28, -6], [-10, 22], [-79, 22], [-56, 99], [-22, 72], [-55, 37], [-61, -51], [5, -62], [-33, -28], [-23, 14], [-44, 3], [-37, 68], [-43, 17], [-10, -24], [-53, -2], [18, 68], [26, 23], [-11, 90], [-20, 70], [-82, 71], [-34, 7], [-63, 76], [-13, -40], [-16, -7], [-9, 66], [-33, 41], [72, 51], [-61, 0], [-17, 49], [-38, 16], [-17, 41], [56, 20], [22, 27], [67, -34], [7, -31]], [[12821, 7609], [-34, -82], [-31, -16], [-41, 16], [-70, -4], [-36, -12], [-6, -63], [37, -74], [23, 37], [56, 2], [-18, -48], [-37, -33], [40, -106], [-8, -29], [38, -96], [0, -55], [-23, -24], [-16, 29], [20, 68], [-41, -32], [-5, 55], [-30, 49], [3, 81], [-28, -25], [5, -216], [-27, -12], [-18, 24], [12, 77], [-6, 80], [-18, 1], [-13, 57], [17, 54], [6, 66], [30, 160], [36, 62], [33, -25], [53, -11], [48, 3], [42, 61], [7, -19]], [[12966, 7585], [-2, -73], [-22, 9], [-18, -52], [-12, 106], [8, 67], [42, -23], [4, -34]], [[12005, 7004], [-46, -2], [-36, 70], [-54, 68], [-49, 118], [-21, 62], [-32, 117], [-37, 69], [-28, 137], [-38, 52], [-22, 71], [-31, 47], [-44, 92], [-4, 42], [92, -19], [37, -82], [56, -91], [40, -89], [42, -2], [36, -57], [24, -69], [32, -38], [-17, -68], [39, -31], [7, -58], [15, -47], [31, -7], [20, -53], [-10, -103], [-2, -129]], [[12512, 7643], [47, -77], [-50, -10], [-14, -57], [2, -75], [-41, -57], [-1, -83], [-22, -97], [-48, -38], [-16, 51], [-30, 5], [-21, 26], [-50, -30], [-16, 41], [-62, 5], [-6, 111], [-21, 24], [-20, 71], [-6, 73], [5, 77], [25, 55], [30, -29], [33, 16], [8, 70], [18, 16], [51, 18], [67, 150], [36, 45], [32, 58], [21, 65], [17, 1], [22, -42], [2, -37], [62, -48], [-3, -33], [-28, -4], [8, -40], [-31, -29], [-24, -75], [31, -79], [-7, -38]], [[12869, 8191], [6, -102], [-14, -76], [-15, 85], [-20, -42], [14, -62], [-12, -39], [-50, 49], [-12, 60], [13, 40], [-27, 39], [-13, -35], [-19, 4], [-32, -47], [-7, 25], [17, 70], [49, 55], [15, -38], [32, 23], [7, 37], [30, 2], [-3, 64], [34, -39], [7, -73]], [[10972, 8007], [-37, -19], [-20, 66], [-7, 120], [19, 135], [29, -47], [20, -58], [20, -87], [-7, -87], [-17, -23]], [[5001, 8332], [-35, -9], [4, 64], [33, 7], [-2, -62]], [[12768, 8346], [-41, -104], [-26, 57], [19, 46], [5, 52], [47, 29], [-4, -80]], [[12538, 8266], [-5, 31], [25, 58], [22, 82], [8, -68], [-28, -45], [-22, -58]], [[12680, 8481], [25, -26], [27, 0], [-1, -35], [-19, -35], [-27, -25], [1, 81], [-6, 40]], [[12832, 8503], [12, -93], [-33, 22], [12, -79], [-20, -18], [-2, 58], [-13, 4], [-6, 51], [24, 25], [-26, 63], [40, -2], [12, -31]], [[12665, 8579], [-11, -72], [-40, 105], [36, -3], [15, -30]], [[12656, 9031], [26, -24], [24, -93], [-11, -69], [-24, -28], [-7, -67], [9, -66], [41, 0], [53, -46], [-4, -45], [13, -20], [-4, -39], [-33, 41], [-26, 13], [-27, 50], [-38, -12], [-21, 18], [2, 35], [-25, 58], [-6, 36], [15, 53], [4, 130], [14, 75], [25, 0]], [[4805, 9008], [-10, -21], [-56, -2], [3, 47], [56, -7], [7, -17]], [[4330, 8978], [-12, -14], [-48, 44], [23, 25], [38, -10], [-1, -45]], [[4512, 9145], [36, -13], [38, 14], [44, -49], [23, 1], [38, -58], [-16, -34], [-20, 18], [-33, 1], [-23, -21], [-21, 9], [-17, -57], [-12, 37], [-28, 14], [-46, 0], [-19, -15], [-23, 26], [4, 27], [70, -19], [-4, 55], [9, 64]], [[12195, 9046], [-36, -40], [-35, 25], [-1, 72], [21, 38], [46, 23], [24, -2], [9, -32], [-18, -36], [-10, -48]], [[1027, 9079], [-16, -2], [-6, 54], [12, 45], [30, -32], [10, -34], [-30, -31]], [[1005, 9209], [-14, -6], [-13, 30], [19, -1], [8, -23]], [[976, 9254], [-1, -9], [-23, 2], [4, 10], [20, -3]], [[939, 9266], [-20, -1], [4, 34], [16, -33]], [[868, 9321], [-5, -9], [-15, 16], [9, 14], [11, -21]], [[4214, 9386], [16, -31], [40, 10], [76, -109], [39, -16], [60, -61], [-5, -19], [-56, -15], [-29, 7], [-60, -8], [28, 46], [-17, 22], [-27, 5], [-25, 72], [-24, -4], [-51, 40], [-55, 13], [1, 37], [-41, 4], [-30, -43], [-45, -30], [14, 63], [40, 35], [42, 17], [69, -7], [40, -28]], [[4304, 9469], [-37, 67], [22, 50], [15, -69], [0, -48]], [[12650, 9388], [-18, -68], [-22, 70], [-5, 62], [25, 81], [34, 63], [19, -24], [-33, -184]], [[4292, 9703], [-46, -13], [-3, 31], [48, 4], [1, -22]], [[4326, 9704], [-7, -59], [-8, 11], [1, 43], [14, 5]], [[13216, 10333], [5, -28], [-24, -51], [-17, 27], [-21, -19], [-12, -49], [-27, 24], [0, 39], [24, 50], [24, -10], [17, 35], [31, -18]], [[9013, 10460], [-29, -35], [5, -23], [-43, -34], [-31, 45], [29, 23], [31, -1], [38, 25]], [[8556, 10463], [23, -28], [33, 4], [53, -10], [-5, -24], [-61, 6], [-51, 16], [8, 36]], [[8212, 10673], [-15, -65], [-2, -69], [-112, 83], [6, 42], [49, -7], [74, 16]], [[7947, 10921], [26, -59], [-6, -110], [-52, -1], [-2, 101], [34, 69]], [[13482, 10582], [-16, -66], [7, -42], [-21, -58], [-54, -40], [-74, -5], [-60, -95], [-28, 32], [-2, 63], [-73, -19], [-50, -39], [-49, -2], [43, -61], [-28, -141], [-27, -35], [-21, 32], [11, 75], [-27, 24], [-17, 57], [40, 26], [22, 52], [42, 43], [31, 57], [83, 25], [45, -17], [44, 148], [28, -40], [86, 116], [26, 102], [-7, 93], [18, 53], [44, 15], [23, -115], [-1, -68], [-39, -84], [1, -86]], [[7962, 10999], [-14, -64], [-19, 17], [-10, 56], [36, 63], [7, -72]], [[13605, 11168], [30, -18], [29, 35], [10, -93], [-63, -23], [-36, -83], [-66, 57], [-23, -91], [-47, -1], [-6, 83], [21, 64], [45, 4], [25, 180], [49, -86], [32, -28]], [[4886, 11365], [31, -11], [3, -37], [-54, 35], [20, 13]], [[4964, 11578], [-74, 25], [30, 25], [44, -50]], [[2373, 11529], [-21, -12], [-69, 38], [-58, 82], [-43, 15], [-13, 65], [109, -40], [35, -68], [42, -34], [18, -46]], [[5203, 11710], [13, -92], [37, -23], [19, 21], [42, -26], [17, -47], [18, -96], [-18, -73], [-46, 13], [9, 68], [-12, 11], [-44, -31], [-40, 21], [-127, -3], [2, 77], [35, 50], [43, 132], [26, 48], [56, 25], [-30, -75]], [[1986, 11989], [41, 7], [-13, -95], [-42, 36], [14, 52]], [[13594, 11715], [42, -148], [-62, 28], [-26, -120], [41, -86], [-33, -8], [-27, -64], [-8, 70], [5, 81], [-5, 90], [10, 63], [1, 111], [-24, 82], [4, 113], [38, 39], [28, -85], [-1, -82], [17, -84]], [[7275, 11841], [-74, -49], [-60, 12], [34, 87], [-21, 85], [88, 104], [36, 3], [45, -51], [-23, -57], [7, -60], [-32, -74]], [[8094, 12120], [-26, -68], [-44, 47], [-6, 35], [62, 27], [14, -41]], [[1134, 12245], [-42, -32], [-28, 61], [60, 42], [46, -32], [-36, -39]], [[7434, 12371], [-45, -90], [89, 11], [-11, -68], [-38, -74], [44, -5], [41, -107], [28, -14], [38, -128], [51, -15], [-5, -54], [-21, -24], [16, -43], [-37, -44], [-57, 1], [-71, -23], [-20, 17], [-27, -39], [-39, 9], [-30, -32], [-22, 17], [61, 87], [-40, 65], [44, 26], [-23, 45], [8, 55], [63, -8], [6, 48], [-29, 53], [-51, 14], [-31, 44], [-3, 80], [-21, 42], [15, 86], [33, 68], [84, 0]], [[606, 12477], [-26, -12], [-53, 38], [75, 6], [4, -32]], [[4231, 12665], [-16, -44], [-30, 32], [46, 12]], [[4121, 12711], [-50, -46], [-38, 24], [31, 38], [57, -16]], [[347, 12800], [52, -8], [76, -33], [-35, -26], [-93, 67]], [[3983, 12956], [54, -46], [94, -54], [65, -61], [-37, -26], [-66, 20], [-23, 37], [-42, -44], [-60, -43], [-35, 82], [20, 142], [30, -7]], [[6951, 13022], [-10, -54], [48, -56], [-55, -64], [-157, -72], [-173, 39], [42, 36], [-92, 41], [75, 16], [-2, 25], [-88, 19], [28, 54], [64, 13], [65, -57], [64, 45], [53, -23], [68, 44], [70, -6]], [[4374, 13080], [-47, -4], [-11, 41], [18, 46], [71, -11], [-31, -72]], [[209, 13033], [19, 40], [114, -13], [82, -78], [-41, -36], [-69, -8], [-1, -82], [-56, -15], [-88, 54], [-10, 36], [-90, 3], [-23, 29], [-46, -64], [0, 332], [213, -146], [-4, -52]], [[3543, 13243], [-26, -29], [-91, 16], [-57, 37], [66, 62], [70, -38], [38, -48]], [[15121, 13387], [-54, 22], [54, 34], [0, -56]], [[55, 13392], [-55, -5], [0, 56], [102, -20], [-47, -31]], [[3757, 13275], [56, -19], [50, -54], [-12, -62], [41, -56], [43, 60], [31, 72], [2, 91], [122, -18], [56, -41], [3, -42], [-31, -44], [29, -45], [-5, -40], [-82, -58], [-115, -30], [-52, -107], [-49, -56], [-60, -5], [-33, -36], [-3, -54], [-49, -10], [-51, -68], [-46, -93], [-16, -66], [-3, -97], [62, -13], [39, -142], [59, 17], [78, -36], [72, -71], [97, -58], [115, -13], [-7, -72], [13, -84], [30, -93], [63, -79], [32, 27], [23, 86], [-22, 131], [-30, 44], [68, 39], [47, 58], [24, 58], [-4, 56], [-28, 71], [-51, 62], [49, 88], [-18, 75], [-14, 130], [29, 19], [115, -31], [35, 22], [91, -76], [13, -32], [75, -7], [-2, -70], [14, -105], [39, -13], [30, -49], [61, 46], [40, 92], [28, 39], [33, -74], [101, -206], [-17, -53], [56, -47], [37, -47], [67, -22], [27, -26], [17, -71], [33, -11], [17, -31], [3, -94], [-61, -60], [-69, -30], [-53, -68], [-71, -14], [-90, 18], [-106, -5], [-36, -60], [-53, -37], [-61, -110], [143, 115], [63, 9], [37, -41], [-40, -56], [27, -152], [55, -42], [69, 12], [43, 94], [2, -61], [28, -30], [-52, -54], [-93, -50], [-42, -34], [-47, -60], [-32, 6], [-1, 71], [72, 69], [-113, -13], [7, -27], [-45, -41], [-88, -53], [-29, -68], [7, -116], [-51, -13], [-3, -32], [-59, -25], [-27, 0], [-8, -77], [-38, -77], [1, -32], [-28, -38], [-24, -2], [1, -79], [12, -6], [11, -112], [-27, -62], [-43, -24], [-28, -49], [-21, -6], [-27, -58], [-46, -54], [-44, -89], [-6, -59], [21, -129], [19, -59], [0, -36], [20, -97], [-3, -88], [-11, -51], [-33, 0], [-23, 55], [-41, 135], [-7, 33], [9, 55], [-12, 46], [-33, 70], [-16, 12], [-42, -37], [-28, 43], [-27, 20], [-47, -10], [-37, 9], [-50, -17], [8, -85], [-62, -1], [-31, 44], [-37, -10], [-30, 19], [-62, -25], [-38, -62], [-42, -36], [-32, -77], [1, -97], [8, -29], [-23, -133], [-7, -152], [20, -86], [8, -64], [28, -62], [26, -89], [45, -22], [17, -35], [127, 61], [27, 34], [21, 143], [72, 41], [63, 4], [9, -58], [-23, -49], [-2, -65], [-17, -101], [-12, -15], [-10, -129], [-24, -54], [34, -16], [21, 16], [50, -8], [18, 18], [43, -1], [26, -13], [51, -70], [-1, -57], [-10, -28], [-6, -70], [3, -59], [-16, -87], [19, -82], [51, -99], [32, -35], [20, 6], [44, 38], [14, 25], [64, -30], [29, -48], [22, -3], [32, 58], [17, 9], [8, 98], [24, 38], [30, 19], [33, -7], [49, 61], [21, 40], [26, -27], [-10, -48], [-24, -9], [13, -38], [0, -44], [-19, -48], [16, -66], [18, 5], [10, 61], [-13, 29], [-3, 63], [53, 34], [-6, 39], [15, 26], [15, -58], [29, -2], [28, -46], [1, -28], [83, 8], [24, -37], [32, -10], [24, 47], [102, 6], [-35, -25], [14, -39], [34, -6], [31, -41], [7, -67], [22, 2], [44, -50], [43, -99], [39, -70], [50, -17], [39, 21], [90, -51], [66, -100], [10, -46], [24, -146], [22, -13], [2, -58], [-32, -68], [13, -26], [74, -13], [2, -83], [32, 55], [53, -30], [69, -51], [21, -49], [-7, -46], [49, 26], [82, -44], [62, 3], [62, -69], [54, -93], [32, -24], [36, -4], [16, -26], [21, -156], [-17, -138], [-21, -54], [-60, -116], [-26, -94], [-31, -72], [-11, -2], [-12, -61], [3, -156], [-16, -183], [-13, -33], [-8, -111], [-42, -109], [-7, -86], [-34, -36], [-10, -50], [-46, 0], [-66, -32], [-29, -37], [-47, -24], [-50, -66], [-35, -83], [-7, -62], [7, -46], [-17, -125], [-29, -45], [-47, -147], [-65, -105], [-20, -79], [-27, -48], [-19, -52], [-47, -46], [-31, 16], [-23, -9], [-39, 36], [-56, 0], [53, -71], [-6, -58], [26, -36], [-2, -40], [-40, -107], [-62, -45], [-85, -17], [-46, 8], [9, -49], [-9, -63], [8, -42], [-25, -29], [-43, -11], [-40, 30], [-17, -22], [6, -83], [29, -25], [23, 27], [12, -44], [-39, -26], [-33, -51], [-16, -129], [-40, 0], [-33, -42], [-12, -63], [41, -61], [40, -17], [-14, -74], [-50, -47], [-27, -98], [-38, -33], [-18, -39], [14, -86], [28, -48], [-55, 5], [-58, -51], [-7, -78], [-65, 25], [-48, 58], [-52, 48], [-14, 53], [12, 48], [-21, 56], [-5, 142], [18, 80], [44, 64], [-64, 24], [40, 74], [15, 138], [46, -29], [22, 172], [-28, 22], [-13, -103], [-27, 11], [28, 273], [19, 57], [-12, 82], [-3, 93], [17, 3], [26, 134], [29, 134], [18, 124], [-10, 124], [13, 69], [-5, 103], [24, 101], [8, 161], [13, 173], [13, 186], [-3, 137], [-8, 117], [-42, 48], [-4, 34], [-83, 83], [-76, 91], [-32, 52], [-17, 68], [6, 24], [-35, 110], [-42, 153], [-39, 166], [-17, 38], [-14, 61], [-32, 54], [-30, 34], [13, 37], [-20, 80], [13, 58], [34, 53], [22, 62], [-25, -3], [-25, 37], [8, 23], [-7, 76], [15, 13], [23, 105], [-3, 34], [52, 51], [10, 32], [8, 72], [21, 5], [34, 96], [-16, 20], [8, 49], [-9, 76], [9, 21], [-7, 71], [-31, 68], [-17, 101], [-21, 23], [-57, -76], [20, -45], [-37, -27], [-35, 74], [-28, 15], [-24, -5], [-32, 36], [4, 32], [-43, 47], [-19, -5], [-29, 49], [3, 79], [-43, 88], [-49, 83], [-24, 2], [-56, 29], [-33, 33], [-27, 1], [-41, 51], [-48, 90], [-56, 48], [-23, -6], [-55, -39], [-61, 38], [-40, 38], [-31, 11], [-48, 39], [-45, 62], [-67, 31], [-17, 38], [-45, 48], [-32, 93], [20, 53], [-32, 141], [-37, 83], [-42, 65], [-21, 52], [-43, 54], [6, 52], [-46, 60], [-11, 58], [-22, 7], [-44, 84], [-40, 152], [1, 32], [-30, 33], [-38, 20], [-7, -34], [11, -103], [72, -144], [8, -54], [48, -93], [14, -77], [24, -76], [3, -44], [20, -2], [32, -75], [-26, -45], [-11, 50], [-28, 48], [-51, 61], [-5, 106], [-49, 63], [-42, 31], [-5, 50], [16, 31], [1, 38], [-32, 59], [-25, 23], [-50, 173], [-24, 118], [-52, 81], [-38, 27], [-39, 8], [-16, 59], [-41, 84], [-52, 162], [-32, 70], [-6, 68], [-23, 45], [10, 69], [-2, 72], [-13, 64], [16, 78], [10, 151], [-7, 112], [-26, 110], [5, 16], [61, -29], [26, 12], [-20, 69], [-111, 117], [-76, 35], [-24, 73], [6, 52], [-53, 35], [-8, 67], [-50, 60], [-1, 43], [-60, 58], [-12, 73], [-55, 67], [-22, 79], [-107, 7], [-49, 24], [-87, 86], [-114, 46], [-58, -7], [-83, 38], [-50, 36], [-46, -18], [8, -58], [-71, -23], [-84, -45], [-8, 130], [-28, -55], [-61, -59], [31, -41], [-40, -59], [-87, -61], [-10, -36], [-66, -43], [-13, -39], [-49, -36], [-29, 6], [-117, -79], [-72, -24], [-7, 14], [88, 65], [44, 45], [52, 10], [21, 34], [99, 96], [7, 63], [21, 49], [-84, -41], [-55, 54], [-68, -34], [4, 80], [-27, 30], [-54, -16], [-65, 59], [0, 47], [-32, 36], [65, 137], [63, -7], [34, 40], [63, 18], [-8, 38], [-63, 28], [-105, -9], [-62, 20], [-71, 82], [153, 75], [29, -41], [89, 3], [-35, 52], [-51, 31], [-70, 77], [-58, 27], [23, 43], [75, 3], [53, 38], [53, 80], [120, 46], [39, -5], [65, 44], [181, -63], [107, -6], [88, -26], [113, -19], [56, 14], [64, -25], [124, -32], [66, -40], [44, -7], [88, 60], [62, -10], [132, 57], [29, -34], [69, 50], [71, -75], [62, -7], [118, 33], [65, -35], [156, -44], [41, 5], [56, -42], [-59, -41], [76, -18], [114, 10], [35, 14], [45, -50], [46, 42], [-43, 36], [27, 28], [85, 12], [76, -65], [47, 7], [74, -38], [127, 12], [-5, 51], [37, 15], [92, -41], [33, -2], [19, 84], [-94, 85], [4, 92], [49, 60], [98, -50], [57, -94], [-37, -41], [78, -17]], [[2765, 13577], [73, -14], [58, -42], [48, 43], [101, 23], [88, -47], [40, -140], [146, -81], [-5, -36], [-56, -70], [-148, 36], [-128, -33], [-181, -21], [-23, 40], [-94, 13], [-52, 66], [93, 23], [32, 30], [-149, -5], [-22, 31], [33, 32], [-74, 22], [65, 95], [112, 51], [43, -16]], [[3171, 13602], [-37, -55], [-65, 58], [102, -3]], [[4354, 13576], [4, -23], [-148, -2], [-47, 44], [22, 35], [97, -9], [72, -45]], [[3925, 13580], [178, 49], [72, -86], [-6, -54], [83, 24], [40, 33], [151, -82], [5, -36], [78, 19], [44, -53], [101, -33], [37, -34], [40, -77], [-78, -39], [99, -55], [67, -18], [60, -76], [67, -6], [-14, -58], [-73, -97], [-52, 36], [-66, 80], [-54, -11], [-6, -47], [45, -49], [74, -60], [27, -83], [-14, -59], [-53, 22], [-106, 67], [104, -122], [6, -29], [-114, 33], [-90, 48], [-51, 41], [15, 23], [-124, 83], [1, -24], [-122, -13], [-35, 29], [28, 61], [165, 12], [-14, 30], [69, 122], [-28, 66], [-64, 40], [-103, 101], [-92, 9], [-77, -11], [-152, 18], [-157, 37], [-35, 30], [-29, 122], [32, 75], [43, 34], [109, 22], [-31, -54]], [[3345, 13637], [136, -31], [-39, -40], [64, -36], [-8, -75], [-69, -32], [-174, 103], [87, 16], [-46, 55], [49, 40]], [[13592, 13585], [-150, 8], [86, 45], [64, -53]], [[3646, 13548], [-45, -62], [-48, 3], [-26, 73], [22, 77], [42, 22], [168, -23], [-63, -74], [-50, -16]], [[2501, 13434], [-111, -42], [-22, 37], [-97, 44], [84, 151], [-41, 51], [142, 13], [60, -18], [107, -4], [86, -59], [-156, -80], [-52, -58], [0, -35]], [[13892, 13740], [-49, -32], [-145, 40], [10, 27], [184, -35]], [[3629, 13732], [-23, -32], [-112, 27], [83, 60], [52, -55]], [[13655, 13780], [-33, -62], [-155, 3], [-70, -20], [-83, 54], [22, 57], [167, 12], [152, -44]], [[3423, 13877], [32, -39], [-17, -105], [-115, 5], [-25, 104], [125, 35]], [[3015, 13833], [98, -19], [-18, -80], [-142, -13], [-106, -36], [-231, 67], [97, 105], [118, -29], [75, -49], [73, -6], [-60, 79], [96, -19]], [[9977, 13377], [-162, 4], [-11, 37], [-76, 22], [-6, 45], [43, 18], [-2, 45], [84, 71], [-39, 10], [101, 73], [-12, 38], [233, 98], [140, 15], [153, 42], [1, -59], [-277, -81], [-130, -79], [-129, -161], [9, -69], [80, -69]], [[3584, 13908], [129, -27], [27, -58], [74, -39], [118, -10], [67, 18], [154, 1], [54, -66], [-89, -40], [-53, 10], [-207, -14], [-179, 37], [-20, 87], [-42, 36], [-136, 36], [103, 29]], [[2680, 13954], [-6, -64], [-150, -69], [-124, 5], [158, 117], [122, 11]], [[12054, 13898], [49, -21], [123, -1], [128, -72], [-10, -43], [-188, -96], [192, -49], [67, 14], [134, -14], [11, -39], [175, -12], [3, 63], [156, -14], [68, -44], [19, -53], [-25, -35], [53, -65], [66, -34], [41, 87], [67, -37], [71, 22], [82, -26], [31, 24], [68, -12], [-30, 77], [56, 36], [379, -54], [36, -49], [110, -64], [169, 16], [84, -14], [35, -34], [-5, -61], [51, -24], [131, 20], [79, -17], [80, 10], [73, -74], [52, 26], [-34, 53], [19, 37], [134, -23], [87, 5], [121, -40], [59, -36], [0, -332], [-54, -37], [-17, -38], [45, -91], [-6, -56], [-79, 18], [-117, -63], [-37, -9], [-126, -110], [-15, -38], [-60, 58], [-110, -66], [-19, 31], [-40, -35], [-56, 11], [-14, -55], [-50, -80], [1, -34], [48, -19], [-6, -121], [-39, -3], [-18, -69], [18, -36], [-74, -43], [-14, -95], [-63, -20], [-12, -85], [-61, -77], [-15, 57], [-18, 122], [-24, 184], [20, 116], [36, 50], [2, 39], [65, 18], [148, 190], [75, 67], [34, 117], [-51, -7], [-25, -68], [-107, -92], [-34, 103], [-109, -29], [-105, -139], [35, -51], [-159, -31], [3, 61], [-65, 12], [-52, -41], [-129, 15], [-138, -25], [-136, -162], [-161, -197], [66, -10], [21, -52], [41, -19], [27, 42], [46, -6], [60, -91], [2, -71], [-33, -83], [-4, -100], [-19, -133], [-63, -120], [-14, -58], [-57, -97], [-84, -145], [-56, -49], [-26, -1], [-26, 41], [-79, -84], [-31, -56], [1, -60], [-45, -58], [-46, -36], [-1, -36], [36, -59], [36, -98], [10, -54], [1, -96], [-16, -46], [-38, -16], [-34, -35], [-38, -7], [-4, 46], [7, 62], [-18, 87], [31, 14], [-29, 71], [-25, 0], [-36, 30], [28, 106], [-47, 45], [-59, -24], [-31, -39], [-31, 49], [33, 55], [-22, 44], [-37, -29], [-47, -58], [-26, -54], [-41, -4], [-22, -39], [22, -56], [35, -14], [1, -37], [33, -24], [47, 59], [38, -32], [27, -3], [7, -43], [-60, -23], [-19, -45], [-41, -42], [-22, -58], [45, -46], [17, -82], [25, -76], [29, -64], [-1, -62], [-26, -23], [10, -44], [25, -26], [-17, -134], [-24, -7], [-65, -200], [-39, -99], [-57, -77], [-59, -70], [-47, -9], [-26, -37], [-14, 27], [-24, -42], [-59, -41], [-44, -13], [-15, -88], [-23, -5], [-11, 61], [10, 32], [-56, 26], [-20, -13], [-56, -71], [-35, -79], [-9, -58], [71, -196], [38, -52], [26, -67], [19, -154], [-6, -146], [-35, -55], [-48, -53], [-34, -70], [-53, -77], [-15, 53], [12, 57], [-31, 47], [-35, 12], [-17, 43], [-22, 86], [-37, 39], [-36, -2], [6, 65], [-37, 0], [-3, -92], [-37, -195], [3, -60], [27, -3], [18, -76], [7, -72], [24, -47], [25, -10], [56, -101], [18, -56], [-2, -94], [7, -78], [15, -23], [16, -73], [-1, -28], [-29, -6], [-40, 62], [-50, 66], [-5, 42], [-24, 56], [-6, 69], [-15, 45], [5, 61], [-26, 67], [-7, 41], [-43, 87], [-15, -3], [17, 132], [-4, 62], [13, 63], [-14, 50], [3, 90], [-17, 43], [-14, 100], [-7, 105], [-18, 69], [-76, -101], [-49, 27], [14, 103], [-9, 78], [-33, 96], [-49, 108], [-12, 44], [-10, 82], [-18, 49], [-38, 3], [3, -34], [-13, -47], [-52, 19], [-6, -31], [-28, 1], [-52, -17], [2, -63], [-22, -49], [-61, -56], [-47, -98], [-31, -52], [-42, -55], [0, -38], [-59, -50], [-20, -5], [-12, -63], [11, -177], [-18, -80], [0, -141], [-22, -4], [-19, -63], [13, -28], [-39, -24], [-14, -56], [-17, -24], [-39, 78], [-36, 200], [-37, 120], [-18, 156], [-38, 114], [-30, 268], [0, 101], [-8, 77], [-61, -49], [-30, 10], [-54, 101], [20, 30], [-13, 32], [-49, 71], [-31, 21], [-12, 60], [-33, 63], [-77, -15], [-68, -2], [-59, -12], [-79, 25], [-94, 30], [-18, 102], [-20, 15], [-32, -15], [-42, -40], [-52, 28], [-42, 64], [-40, 23], [-29, 79], [-31, 111], [-22, -13], [-27, 27], [-16, -32], [-24, 4], [5, -56], [30, -134], [56, -84], [-2, -62], [18, -51], [20, 57], [24, -18], [-8, -97], [17, -51], [33, 13], [60, -4], [60, 109], [35, 23], [5, -65], [19, -57], [24, -31], [55, -26], [46, -104], [-22, -73], [-18, -27], [-16, -57], [-19, 5], [-15, -62], [5, -56], [-50, -41], [-13, -58], [-27, 1], [-16, -21], [0, -34], [-20, -23], [-23, 8], [-28, -28], [-50, -27], [-9, -66], [-42, -35], [-67, -39], [-38, -58], [-31, 0], [-24, -35], [-27, -16], [-46, -9], [-27, -49], [-63, -5], [-11, 48], [-22, 208], [-2, 88], [-16, 58], [-22, 30], [-22, 70], [-12, 68], [-29, 57], [-19, 14], [-28, 79], [-3, 107], [-24, 93], [-42, 49], [-23, 110], [-76, 205], [-21, -1], [-30, -34], [-24, 5], [32, -130], [29, -92], [38, -93], [-7, -68], [56, -92], [14, -82], [-10, -15], [6, -85], [16, -100], [39, -51], [24, -96], [12, -77], [23, -40], [57, -79], [59, -124], [31, -51], [-1, -34], [-24, -20], [31, -38], [28, -70], [20, 0], [40, 21], [46, 10], [73, 47], [37, 4], [42, 21], [35, 29], [-2, -115], [-21, -120], [-46, -200], [-36, -122], [-36, -93], [-50, -113], [-42, -68], [-63, -82], [-39, -64], [-46, -101], [-19, -63], [-55, -74], [-6, -59], [-14, -33], [-8, -56], [-17, -27], [-19, -103], [2, -47], [27, -30], [-10, -72], [-1, -65], [32, -135], [23, -55], [-2, -83], [5, -73], [2, -130], [7, -41], [-29, -117], [-26, -52], [-86, -72], [-48, -89], [-16, -15], [-46, -79], [-4, -59], [36, -133], [-4, -169], [-18, -29], [-85, -74], [-18, -30], [14, -41], [-19, -174], [-11, -37], [-37, -54], [-53, -145], [-77, -136], [-32, -38], [-71, -59], [-25, 12], [-21, -16], [-45, 16], [-43, -6], [-44, -32], [-36, -14], [-45, -33], [-32, 31], [-25, 48], [0, 49], [-14, 56], [14, 15], [-1, 64], [-28, 78], [-51, 178], [-31, 63], [-17, 61], [-19, 141], [-14, 129], [-1, 99], [-6, 46], [-38, 103], [-31, 152], [-34, 81], [-7, 116], [6, 73], [17, 112], [24, 109], [37, 92], [2, 109], [-12, 30], [-22, 100], [15, 50], [-21, 136], [-34, 158], [-35, 88], [-43, 84], [-27, 68], [-26, 86], [29, 177], [-8, 13], [21, 159], [-16, 55], [-20, 14], [-18, 72], [-76, -44], [-34, 2], [-22, 52], [-14, 60], [-30, 55], [-68, -1], [-69, -28], [-66, -48], [-23, -29], [-38, -24], [-37, 24], [-49, 15], [-77, -15], [-70, -55], [-19, 2], [-44, 39], [-38, 64], [-36, 45], [-28, 54], [-42, 39], [-21, 45], [-13, 92], [-35, 82], [-21, 27], [-11, 55], [-34, 49], [-18, 5], [-22, 54], [-10, 82], [5, 37], [-17, 64], [-2, 46], [30, 101], [-4, 45], [12, 41], [5, 78], [-9, 124], [4, 41], [-11, 40], [-22, 36], [4, 74], [29, 66], [-2, 28], [14, 59], [38, 66], [12, 93], [15, 51], [28, 31], [27, 85], [21, 33], [40, 9], [54, 79], [35, 69], [-11, 104], [22, 115], [27, 57], [73, 72], [41, 137], [31, 0], [26, -35], [40, 5], [61, -19], [41, 46], [45, 14], [27, 34], [40, 26], [141, 21], [21, -12], [40, 33], [44, 0], [17, -19], [29, 5], [46, 34], [29, -10], [-1, -42], [18, -27], [14, -59], [-6, -72], [-27, -42], [8, -45], [22, -1], [10, -40], [65, -42], [53, -6], [56, -38], [20, -73], [96, -51], [45, -42], [41, 60], [-10, 64], [13, 40], [30, 39], [29, 12], [57, -17], [15, -38], [70, -24], [10, -27], [56, 1], [102, -60], [50, 51], [37, 6], [84, -44], [33, -5], [21, 21], [20, 71], [9, 63], [22, 90], [22, 62], [-4, 63], [10, 34], [-25, 62], [-35, 20], [-29, -48], [-64, -10], [-34, 45], [-45, 3], [-10, -35], [-29, -10], [-41, 45], [-45, -2], [-25, 83], [-31, 46], [20, 65], [-26, 40], [46, 79], [65, 4], [18, 63], [80, -11], [50, 54], [49, 23], [70, 2], [73, -59], [60, -32], [49, 13], [36, -7], [50, 43], [6, 36], [-10, 56], [-48, 41], [-69, 96], [-48, 31], [-36, 49], [31, 13], [34, 70], [-23, 33], [62, 34], [-1, 18], [-72, -20], [-27, -27], [-40, -5], [-36, -31], [2, -51], [56, -45], [-46, -15], [-57, -48], [-24, 17], [10, 39], [-46, 25], [47, 43], [-12, 19], [-65, 21], [-3, 31], [-39, -10], [-48, -107], [-32, -32], [-12, -100], [-22, -35], [-15, -59], [18, -80], [29, -47], [-49, -4], [-53, -71], [-13, 56], [-48, 10], [-50, -22], [29, -46], [-45, -14], [-21, -25], [21, -39], [-16, -18], [45, -63], [0, -47], [-53, -29], [16, -73], [-28, -2], [-34, 37], [-23, 122], [-38, 85], [-11, 48], [-23, 28], [-4, 40], [9, 82], [-27, 47], [-121, 102], [-35, 61], [-12, 70], [-74, 55], [-34, -30], [-2, -65], [13, -42], [40, -42], [21, -69], [47, -67], [32, 1], [-1, -35], [68, -56], [10, -50], [-37, 14], [-18, -54], [31, -31], [-45, -119], [0, 81], [-29, 90], [-30, 47], [-27, 15], [-18, 33], [-31, 6], [-33, 37], [-67, 102], [-13, 83], [-55, 37], [-99, -103], [-83, 22], [-61, -27], [-3, -98], [-40, -56], [-53, -17], [-30, -74], [-16, -68], [16, -48], [-24, -37], [-9, -54], [-32, -17], [-30, -64], [-93, 1], [-42, -61], [-21, 7], [-27, 76], [-40, 13], [-16, -22], [-44, 3], [6, 65], [-4, 51], [-29, 39], [4, 55], [16, 30], [12, 84], [-9, 65], [0, 87], [-17, 36], [59, 60], [52, -15], [56, 1], [45, -14], [103, 1], [21, 50], [8, 166], [-43, 87], [-31, 42], [-64, 32], [-4, 61], [54, 18], [71, -21], [-14, 94], [40, -36], [98, 65], [12, 68], [71, 34], [21, 22], [37, 123], [58, 35], [35, -3], [79, 45], [-11, 79], [-17, 46], [-2, 85], [19, 47], [37, 6], [35, -24], [5, -58], [-30, -60], [12, -73], [85, -33], [23, 23], [68, -60], [28, 25], [119, 66], [85, -35], [10, 37], [58, 27], [-8, 132], [21, 53], [40, 28], [33, -62], [34, 1], [13, 113], [-43, 19], [-3, 48], [106, 36], [89, -12], [48, 46], [-44, 40], [-77, -7], [-74, -30], [-68, -18], [-24, 46], [-41, 27], [9, 82], [-20, 75], [58, 101], [124, 107], [-4, 36], [-58, 39], [-73, -24], [-40, -58], [6, -51], [-67, -67], [-81, -71], [-30, -117], [29, -59], [41, -46], [-39, -94], [-44, -20], [-16, -139], [-24, -78], [-50, 8], [-24, -66], [-49, -4], [-13, 79], [-35, 94], [-32, 118], [-28, 51], [-83, -96], [-56, -20], [-59, 42], [-15, 90], [-13, 192], [39, 54], [111, 69], [83, 86], [77, 116], [101, 161], [185, 167], [92, 37], [70, -5], [64, 69], [76, -4], [76, 17], [131, -61], [-54, -22], [46, -53], [43, 29], [69, -50], [115, -20], [159, -94], [32, -39], [3, -56], [-47, -43], [-68, -23], [-188, 64], [-31, -11], [69, -61], [5, -124], [87, -47], [6, 41], [-27, 37], [28, 30], [102, -52], [35, 21], [-28, 60], [98, 82], [78, -34], [24, 57], [-35, 50], [21, 50], [-31, 51], [117, -26], [24, -47], [-53, -10], [0, -47], [33, -28], [65, 18], [10, 53], [88, 40], [147, 71], [-10, -54], [52, -9], [30, 28], [79, 3], [62, 34], [48, -50], [48, 55], [-44, 48], [22, 28], [124, -25], [210, -122], [28, 44], [-94, 70], [14, 39], [-24, 92], [77, 75], [28, 76], [31, 16], [111, -22], [9, -46], [-40, -67], [40, -85], [-10, -114], [47, -51], [-18, -56], [-83, -118], [48, -12], [63, 51], [48, 81], [-25, 47], [20, 55], [-46, 7], [-10, 46], [34, 84], [-55, 68], [108, 71], [167, 1], [40, 22], [-4, 89], [73, 17], [101, -4], [91, 11], [-34, 43], [49, 55], [130, 44], [111, 11], [14, 23], [110, 7], [34, -18], [95, 44], [77, -2], [51, 72], [100, 34], [110, -60]], [[9623, 10927], [22, -59], [-17, -127], [-15, -19], [14, -103], [40, -17], [29, -42], [60, -14], [65, 22], [-3, 78], [6, 87], [-33, 28], [11, 57], [-28, 5], [9, 70], [40, -20], [37, 26], [-31, 50], [-12, 48], [-34, -21], [-17, 77], [-49, 28], [-19, 75], [16, 40], [2, 61], [36, 13], [36, -12], [8, 81], [-8, 52], [-42, -4], [-35, 20], [-49, -37], [-39, -17], [-19, -49], [-41, -14], [-42, -86], [38, -79], [-4, -56], [68, -142]], [[3619, 13943], [-98, 3], [-11, 23], [84, -1], [25, -25]], [[2932, 13958], [-78, -24], [-62, 27], [34, 26], [106, -29]], [[8599, 13971], [-94, -34], [-74, 19], [4, 48], [87, 17], [77, -50]], [[2954, 14033], [-121, -16], [44, 37], [77, -21]], [[3535, 13988], [-96, 2], [-21, 66], [129, -38], [-12, -30]], [[3358, 14010], [-53, -25], [-172, 75], [-3, 31], [196, -41], [32, -40]], [[11974, 14009], [-237, -32], [77, 109], [66, 4], [106, -47], [-12, -34]], [[8327, 14125], [138, -62], [-105, -33], [-60, -77], [-20, -69], [-51, -3], [-90, 51], [-25, 53], [-82, 70], [-33, 66], [115, 29], [160, 4], [53, -29]], [[8629, 14184], [83, -30], [-63, -45], [-121, -9], [-124, 14], [-114, 62], [233, 28], [106, -20]], [[9708, 14195], [-194, -25], [12, 44], [182, -19]], [[11758, 14056], [-91, -10], [-187, 56], [-32, 60], [-58, 16], [200, 76], [179, -123], [-11, -75]], [[3905, 14121], [51, -27], [-135, -87], [-162, 5], [-44, 64], [-117, 87], [83, 87], [98, 4], [54, -44], [139, -34], [33, -55]], [[4683, 14408], [203, -17], [75, -45], [-390, -213], [-212, -65], [35, -41], [-184, -110], [79, -36], [-112, -50], [-110, 23], [-123, -12], [-142, 14], [-6, 40], [78, 19], [-21, 60], [47, 71], [86, 49], [-105, 98], [-74, 28], [-93, 86], [194, 32], [321, 71], [454, -2]], [[6422, 14443], [263, -66], [-78, -32], [-217, -18], [304, -50], [204, 32], [126, -16], [24, -36], [-232, -97], [-83, -114], [1, -93], [51, -54], [-135, -30], [77, -44], [10, -71], [-45, -8], [55, -71], [-59, -69], [-117, -14], [52, -56], [-47, -46], [55, -50], [16, -67], [-75, -17], [-70, 24], [-49, -44], [169, -8], [-113, -72], [-114, -66], [-123, -29], [-46, 0], [-44, -32], [-58, -88], [-90, -58], [-146, -44], [-36, -51], [0, -59], [-22, -54], [-68, -67], [17, -65], [-41, -150], [-59, -5], [-62, 68], [-84, 0], [-40, 46], [-28, 81], [-73, 104], [-22, 54], [-5, 75], [-58, 77], [15, 61], [-28, 29], [41, 98], [63, 31], [26, 99], [-109, -53], [-51, 27], [13, 101], [125, -21], [-110, 81], [-77, 9], [47, 78], [-25, 31], [-84, 145], [-54, 33], [1, 34], [-113, 49], [-304, -3], [-122, 79], [111, 26], [-190, 60], [6, 32], [312, 80], [17, 30], [-114, 30], [182, 92], [44, 46], [229, 35], [129, 1], [309, 35], [141, 50], [201, 27], [484, -2]]],
  transform: {
    scale: [.02380794920970836, .012014472135687088],
    translate: [-180, -90.00000000000003]
  },
  objects: {
    land: {
      type: "GeometryCollection",
      geometries: [{
        arcs: [[0]],
        type: "Polygon"
      }, {
        arcs: [[1]],
        type: "Polygon"
      }, {
        arcs: [[2]],
        type: "Polygon"
      }, {
        arcs: [[3]],
        type: "Polygon"
      }, {
        arcs: [[4]],
        type: "Polygon"
      }, {
        arcs: [[5]],
        type: "Polygon"
      }, {
        arcs: [[6]],
        type: "Polygon"
      }, {
        arcs: [[7]],
        type: "Polygon"
      }, {
        arcs: [[8]],
        type: "Polygon"
      }, {
        arcs: [[9]],
        type: "Polygon"
      }, {
        arcs: [[10]],
        type: "Polygon"
      }, {
        arcs: [[11]],
        type: "Polygon"
      }, {
        arcs: [[12]],
        type: "Polygon"
      }, {
        arcs: [[13]],
        type: "Polygon"
      }, {
        arcs: [[14]],
        type: "Polygon"
      }, {
        arcs: [[15]],
        type: "Polygon"
      }, {
        arcs: [[16]],
        type: "Polygon"
      }, {
        arcs: [[17]],
        type: "Polygon"
      }, {
        arcs: [[18]],
        type: "Polygon"
      }, {
        arcs: [[19]],
        type: "Polygon"
      }, {
        arcs: [[20]],
        type: "Polygon"
      }, {
        arcs: [[21]],
        type: "Polygon"
      }, {
        arcs: [[22]],
        type: "Polygon"
      }, {
        arcs: [[23]],
        type: "Polygon"
      }, {
        arcs: [[24]],
        type: "Polygon"
      }, {
        arcs: [[25]],
        type: "Polygon"
      }, {
        arcs: [[26]],
        type: "Polygon"
      }, {
        arcs: [[27]],
        type: "Polygon"
      }, {
        arcs: [[28]],
        type: "Polygon"
      }, {
        arcs: [[29]],
        type: "Polygon"
      }, {
        arcs: [[30]],
        type: "Polygon"
      }, {
        arcs: [[31]],
        type: "Polygon"
      }, {
        arcs: [[32]],
        type: "Polygon"
      }, {
        arcs: [[33]],
        type: "Polygon"
      }, {
        arcs: [[34]],
        type: "Polygon"
      }, {
        arcs: [[35]],
        type: "Polygon"
      }, {
        arcs: [[36]],
        type: "Polygon"
      }, {
        arcs: [[37]],
        type: "Polygon"
      }, {
        arcs: [[38]],
        type: "Polygon"
      }, {
        arcs: [[39]],
        type: "Polygon"
      }, {
        arcs: [[40]],
        type: "Polygon"
      }, {
        arcs: [[41]],
        type: "Polygon"
      }, {
        arcs: [[42]],
        type: "Polygon"
      }, {
        arcs: [[43]],
        type: "Polygon"
      }, {
        arcs: [[44]],
        type: "Polygon"
      }, {
        arcs: [[45]],
        type: "Polygon"
      }, {
        arcs: [[46]],
        type: "Polygon"
      }, {
        arcs: [[47]],
        type: "Polygon"
      }, {
        arcs: [[48]],
        type: "Polygon"
      }, {
        arcs: [[49]],
        type: "Polygon"
      }, {
        arcs: [[50]],
        type: "Polygon"
      }, {
        arcs: [[51]],
        type: "Polygon"
      }, {
        arcs: [[52]],
        type: "Polygon"
      }, {
        arcs: [[53]],
        type: "Polygon"
      }, {
        arcs: [[54]],
        type: "Polygon"
      }, {
        arcs: [[55]],
        type: "Polygon"
      }, {
        arcs: [[56]],
        type: "Polygon"
      }, {
        arcs: [[57]],
        type: "Polygon"
      }, {
        arcs: [[58]],
        type: "Polygon"
      }, {
        arcs: [[59]],
        type: "Polygon"
      }, {
        arcs: [[60]],
        type: "Polygon"
      }, {
        arcs: [[61]],
        type: "Polygon"
      }, {
        arcs: [[62]],
        type: "Polygon"
      }, {
        arcs: [[63]],
        type: "Polygon"
      }, {
        arcs: [[64]],
        type: "Polygon"
      }, {
        arcs: [[65]],
        type: "Polygon"
      }, {
        arcs: [[66]],
        type: "Polygon"
      }, {
        arcs: [[67]],
        type: "Polygon"
      }, {
        arcs: [[68]],
        type: "Polygon"
      }, {
        arcs: [[69]],
        type: "Polygon"
      }, {
        arcs: [[70]],
        type: "Polygon"
      }, {
        arcs: [[71]],
        type: "Polygon"
      }, {
        arcs: [[72]],
        type: "Polygon"
      }, {
        arcs: [[73]],
        type: "Polygon"
      }, {
        arcs: [[74]],
        type: "Polygon"
      }, {
        arcs: [[75]],
        type: "Polygon"
      }, {
        arcs: [[76]],
        type: "Polygon"
      }, {
        arcs: [[77]],
        type: "Polygon"
      }, {
        arcs: [[78]],
        type: "Polygon"
      }, {
        arcs: [[79]],
        type: "Polygon"
      }, {
        arcs: [[80]],
        type: "Polygon"
      }, {
        arcs: [[81]],
        type: "Polygon"
      }, {
        arcs: [[82]],
        type: "Polygon"
      }, {
        arcs: [[83]],
        type: "Polygon"
      }, {
        arcs: [[84]],
        type: "Polygon"
      }, {
        arcs: [[85]],
        type: "Polygon"
      }, {
        arcs: [[86]],
        type: "Polygon"
      }, {
        arcs: [[87]],
        type: "Polygon"
      }, {
        arcs: [[88]],
        type: "Polygon"
      }, {
        arcs: [[89]],
        type: "Polygon"
      }, {
        arcs: [[90]],
        type: "Polygon"
      }, {
        arcs: [[91]],
        type: "Polygon"
      }, {
        arcs: [[92]],
        type: "Polygon"
      }, {
        arcs: [[93]],
        type: "Polygon"
      }, {
        arcs: [[94]],
        type: "Polygon"
      }, {
        arcs: [[95]],
        type: "Polygon"
      }, {
        arcs: [[96]],
        type: "Polygon"
      }, {
        arcs: [[97]],
        type: "Polygon"
      }, {
        arcs: [[98]],
        type: "Polygon"
      }, {
        arcs: [[99]],
        type: "Polygon"
      }, {
        arcs: [[100]],
        type: "Polygon"
      }, {
        arcs: [[101]],
        type: "Polygon"
      }, {
        arcs: [[102]],
        type: "Polygon"
      }, {
        arcs: [[103]],
        type: "Polygon"
      }, {
        arcs: [[104]],
        type: "Polygon"
      }, {
        arcs: [[105]],
        type: "Polygon"
      }, {
        arcs: [[106]],
        type: "Polygon"
      }, {
        arcs: [[107]],
        type: "Polygon"
      }, {
        arcs: [[108]],
        type: "Polygon"
      }, {
        arcs: [[109]],
        type: "Polygon"
      }, {
        arcs: [[110]],
        type: "Polygon"
      }, {
        arcs: [[111]],
        type: "Polygon"
      }, {
        arcs: [[112], [113]],
        type: "Polygon"
      }, {
        arcs: [[114]],
        type: "Polygon"
      }, {
        arcs: [[115]],
        type: "Polygon"
      }, {
        arcs: [[116]],
        type: "Polygon"
      }, {
        arcs: [[117]],
        type: "Polygon"
      }, {
        arcs: [[118]],
        type: "Polygon"
      }, {
        arcs: [[119]],
        type: "Polygon"
      }, {
        arcs: [[120]],
        type: "Polygon"
      }, {
        arcs: [[121]],
        type: "Polygon"
      }, {
        arcs: [[122]],
        type: "Polygon"
      }, {
        arcs: [[123]],
        type: "Polygon"
      }, {
        arcs: [[124]],
        type: "Polygon"
      }, {
        arcs: [[125]],
        type: "Polygon"
      }, {
        arcs: [[126]],
        type: "Polygon"
      }, {
        arcs: [[127]],
        type: "Polygon"
      }]
    }
  }
},
    Nt = {
  minZoom: 2.5,
  center: [0, 0],
  zoom: 3,
  bounds: {
    north: 25,
    south: -25,
    east: 40,
    west: -40
  },
  size: 40,
  viewportThickness: 6
},
    jt = function (a) {
  function c() {
    var n, t, i;
    return o(this, c), (n = e(this, r(c).call(this))).state = {
      projection: null
    }, n.worldData = (t = kt, i = kt.objects.land, "string" == typeof i && (i = t.objects[i]), "GeometryCollection" === i.type ? {
      type: "FeatureCollection",
      features: i.geometries.map(function (n) {
        return bt(t, n);
      })
    } : bt(t, i)).features, n;
  }

  return n(c, u), t(c, [{
    key: "componentDidMount",
    value: function value() {
      this.setProjection();
    }
  }, {
    key: "componentDidUpdate",
    value: function value(n) {
      this.props.center[0] === n.center[0] && this.props.center[1] === n.center[1] || this.recenter();
    }
  }, {
    key: "setProjection",
    value: function value() {
      var n = this.props,
          t = n.center,
          o = n.size,
          e = i(t, 2),
          r = e[0],
          l = e[1],
          u = Et().translate([o / 2, o / 2]).scale(o / 2).clipAngle(90);
      u.rotate([-l, -r]), this.setState({
        projection: u
      });
    }
  }, {
    key: "recenter",
    value: function value() {
      if (this.state.projection) {
        var n = this.props.center,
            t = i(n, 2),
            o = t[0],
            e = t[1],
            r = this.state.projection;
        this.state.projection.rotate([-e, -o]), this.setState({
          projection: r
        });
      }
    }
  }, {
    key: "render",
    value: function value() {
      var n = this,
          t = this.props,
          o = t.zoom,
          e = t.bounds,
          r = t.size,
          i = t.viewportThickness;
      if (void 0 === e) return console.error("MiniGlobe: bounds not specified"), null;
      var u = e.north,
          a = e.south,
          c = e.west,
          s = e.east,
          p = {
        type: "Feature",
        geometry: {
          type: "Polygon",
          coordinates: [[[c, u], [s, u], [s, a], [c, a], [c, u]]]
        }
      };
      return l.createElement("svg", {
        width: r,
        height: r,
        className: xt
      }, l.createElement("circle", {
        className: wt,
        cx: r / 2,
        cy: r / 2,
        r: r / 2
      }), l.createElement("g", null, this.worldData.map(function (t, o) {
        return l.createElement("path", {
          key: "path-".concat(o),
          d: at().projection(n.state.projection)(t)
        });
      }), o > Nt.minZoom && l.createElement("path", {
        key: "viewport",
        d: at().projection(this.state.projection)(p),
        className: Mt,
        style: {
          strokeWidth: i
        }
      })));
    }
  }]), c;
}();

jt.propTypes = {
  center: a.arrayOf(a.number).isRequired,
  zoom: a.number.isRequired,
  bounds: a.shape({
    north: a.number,
    south: a.number,
    west: a.number,
    east: a.number
  }).isRequired,
  size: a.number.isRequired,
  viewportThickness: a.number.isRequired
}, jt.defaultProps = {
  center: Nt.center,
  zoom: Nt.zoom,
  bounds: Nt.bounds,
  size: Nt.size,
  viewportThickness: Nt.viewportThickness
};
export { jt as M };